// CasosList.jsx
import { useEffect, useState, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../controls/DashboardLayout";
import DashboardNavbar from "../../controls/DashboardNavbar";
import MDBox from "../../controls/MDBox";
import WhatsAppCaso from "../Mensaje/WhatsAppCaso";
import PuntajeCaso from "./PuntajeCaso";
import { recargarResumenGestion } from "../../controls/ResumenGestionBanner";
import PanelPropuesta from "./PanelPropuesta";
import { fetchPerfilActual } from "../../Utils/PerfilActual";
import { Grid, Collapse, IconButton as MuiIconButton, Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, Checkbox, FormControlLabel, Paper, Switch, List, ListItem, ListItemText, Divider, IconButton, Link, Chip } from "@mui/material";
import { Card } from "react-bootstrap";
import Draggable from 'react-draggable';
import MDTypography from "../../controls/MDTypography";
import ManualAyuda from "../../controls/ManualAyuda";
import MDButton from "../../controls/MDButton";
import getCookie from "../../Utils/getcookies";
import setCookie from "../../Utils/setcookie";
import MDInput from "../../controls/MDInput";
import DataTable from "../../controls/Tables/DataTable";
import { Calendar, CalendarEvent, PersonCheck, PersonGear, ListTask } from "react-bootstrap-icons";
import { getData, postData, pathData, deleteData } from "../../Utils/Http/api";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from "react-router-dom";
import { fetchOrganismos } from "../../Utils/Organismo";
import { fetchCasoEventoTipos } from "../../Utils/CasoEventoTipo";
import { fetchCasoEtapas } from "../../Utils/CasoEtapa";
import { fetchCasoEstados } from "../../Utils/CasoEstado";
import { fetchUsuarios } from "../../Utils/Usuarios";
import { tiposCierre, tiposCierreCualitativo, getTipoCierreDescripcion } from "../../Utils/TipoCierre";
import { fetchMotivosCualitativos } from "../../Utils/MotivoCualitativo";
import { etiquetaTipoCaso } from "../../Utils/TipoCaso";
import { fetchCasoCualitativoEstados, fetchCasoCualitativoEventoTipos } from "../../Utils/CasoCualitativoCatalogo";
import { fetchSujetoContactoTipos } from "../../Utils/SujetoContactoTipo";
import { fetchSujetoContactoOrigenes } from "../../Utils/SujetoContactoOrigen";
import { fetchSujetoContactoPrioridades } from "../../Utils/SujetoContactoPrioridad";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { ExpandMore, ExpandLess, Phone, Email, Notifications, Print, EmailOutlined, Height, InfoOutlined, ContactsOutlined, Close, Edit, History, Error, Warning, CheckCircle, RadioButtonUnchecked, FileDownload, Add, SwapHoriz } from "@mui/icons-material";
import Badge from '@mui/material/Badge';
import ExcelJS from 'exceljs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

// Componente para hacer los diálogos arrastrables
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

// La misma pantalla sirve para Gestión Pre-Judicial y para Gestión de Casos Cualitativos: cada modo llama a sus
// propios endpoints y usa los estados de su instancia (etapa). El resto del comportamiento es el mismo.
const CONFIG_MODOS = {
  prejudicial: {
    titulo: "Gestion Pre-Judicial",
    ayuda: "Gestión Pre-Judicial",
    cookiePrefix: "caso",
    tablaStorage: "gestion-prejudicial-table",
    idCasoEtapa: 1,
    // Catálogo de estados y de tipos de evento de la pantalla (Pre-Judicial: instancia 1 del catálogo compartido).
    fetchEstados: fetchCasoEstados,
    fetchTiposEvento: (idCasoEstado) => fetchCasoEventoTipos(idCasoEstado, 1),
    tipoAgenda: "PRE-JUDICIAL",
    tiposCierre: tiposCierre,
    usaMotivo: false,
    permiteVincular: true,
    permiteCasosDelSujeto: true,
    api: {
      listar: "/CasoListar",
      listarDetallado: "/CasoAntListar",
      registrarEvento: "/CasoEventoRegistrar",
      eventosPorCaso: (idCaso) => `/CasoEventoByIdCasoListar/${idCaso}`,
      actualizarGestor: "/UpdateGestorCaso",
      mailSeguimiento: "/SendMailSeguimientoCaso",
      vincularSujetoReal: "/CasoVincularSujetoReal",
      casosPorSujeto: (idSujeto) => `/CasoListarxSujeto?idSujeto=${idSujeto}`,
    },
  },
  cualitativo: {
    titulo: "Gestion de Casos Cualitativos",
    ayuda: "Gestión de Casos Cualitativos",
    cookiePrefix: "casoCualitativo",
    tablaStorage: "gestion-cualitativa-table",
    idCasoEtapa: 0, // el catálogo cualitativo no tiene etapas
    // Catálogo propio (Configuraciones Casos Cualitativos); se ofrecen todos los tipos activos que no son de sistema.
    fetchEstados: fetchCasoCualitativoEstados,
    fetchTiposEvento: () => fetchCasoCualitativoEventoTipos(),
    tipoAgenda: "CUALITATIVO",
    tiposCierre: tiposCierreCualitativo,
    usaMotivo: true,
    permiteVincular: true,
    permiteCasosDelSujeto: true, // los casos cualitativos del sujeto (no incluye los de Pre-Judicial)
    api: {
      listar: "/CasoCualitativoListar",
      listarDetallado: "/CasoCualitativoListar",
      registrarEvento: "/CasoCualitativoEventoRegistrar",
      eventosPorCaso: (idCaso) => `/CasoCualitativoEventoListar/${idCaso}`,
      actualizarGestor: "/UpdateGestorCasoCualitativo",
      mailSeguimiento: "/SendMailSeguimientoCasoCualitativo",
      vincularSujetoReal: "/CasoCualitativoVincularSujetoReal",
      casosPorSujeto: (idSujeto) => `/CasoCualitativoListarxSujeto?idSujeto=${idSujeto}`,
    },
  },
};

// Puntaje y marca de prioritario (la estrella) de una lista de casos, en tandas de lo que acepta el backend por pedido. Va por un
// endpoint que no exige poder administrar el Disparador: el puntaje y la estrella de la grilla de Pre-Judicial (y el puntaje del
// Excel) los ve todo usuario. Un caso que no tiene puntaje guardado (por ejemplo, un caso cerrado que todavía no se calculó) no
// viene. Devuelve { idCaso: { idCaso, puntaje, prioritario } }.
const TANDA_PUNTAJES = 1000;
const puntajesDeCasos = async (idsCaso) => {
  const ids = [...new Set(idsCaso)];
  const porCaso = {};
  for (let i = 0; i < ids.length; i += TANDA_PUNTAJES) {
    const res = await postData("/CasoPuntajeValores", { idsCaso: ids.slice(i, i + TANDA_PUNTAJES) });
    (res?.value || []).forEach((p) => { porCaso[p.idCaso] = p; });
  }
  return porCaso;
};

// La información temporal de un sujeto vinculado llega con una fila por contacto de cada sujeto provisorio (el que se inventó al importar)
// vinculado a él; un provisorio que ya no tiene contactos (porque nunca los tuvo o porque se transfirieron todos al sujeto real) llega
// en una sola fila con el contacto en null. Se agrupa por provisorio: { idSujetoInventado, tipoIdentificacion, identificacion, contactos }.
const agruparProvisorios = (filas) => {
  const porId = new Map();
  (filas || []).forEach((f) => {
    if (!porId.has(f.idSujetoInventado)) {
      porId.set(f.idSujetoInventado, { idSujetoInventado: f.idSujetoInventado, tipoIdentificacion: f.tipoIdentificacion, identificacion: f.identificacion, contactos: [] });
    }
    if (f.idSujetoContacto) porId.get(f.idSujetoInventado).contactos.push(f);
  });
  return [...porId.values()];
};

function CasosList({ modo = "prejudicial" }) {
  const cfg = CONFIG_MODOS[modo] || CONFIG_MODOS.prejudicial;
   // Limpiar el storage al cargar el componente
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [currentTablePage, setCurrentTablePage] = useState(0);
  const [entriesPerPage, setEntriesPerPage] = useState(() => {
    const cookieValue = getCookie(`${cfg.cookiePrefix}EntriesPerPage`);
    return cookieValue ? parseInt(cookieValue) : 10;
  });
  const [filters, setFilters] = useState(() => {
    // Cargar valores desde cookies
    const cookieNombreSujeto = getCookie(`${cfg.cookiePrefix}FiltroNombreSujeto`) || "";
    const cookieIdentificacion = getCookie(`${cfg.cookiePrefix}FiltroIdentificacion`) || "";
    const cookieIdOrganismo = getCookie(`${cfg.cookiePrefix}FiltroIdOrganismo`);
    const cookieIdCasoEstado = getCookie(`${cfg.cookiePrefix}FiltroIdCasoEstado`);
    const cookieIdUsuario = getCookie(`${cfg.cookiePrefix}FiltroIdUsuario`);
    const cookieCantObjetosDesde = getCookie(`${cfg.cookiePrefix}FiltroCantObjetosDesde`) || "";
    const cookieCantObjetosHasta = getCookie(`${cfg.cookiePrefix}FiltroCantObjetosHasta`) || "";
    const cookieMontoDesde = getCookie(`${cfg.cookiePrefix}FiltroMontoDesde`) || "";
    const cookieMontoHasta = getCookie(`${cfg.cookiePrefix}FiltroMontoHasta`) || "";
    const cookieNumeroCaso = getCookie(`${cfg.cookiePrefix}FiltroNumeroCaso`) || "";
    const cookieObjetos = getCookie(`${cfg.cookiePrefix}FiltroObjetos`) || "";
    const cookiePoseeContactos = getCookie(`${cfg.cookiePrefix}FiltroPoseeContactos`) || "Todos";
    const cookiePoseeCuit = getCookie(`${cfg.cookiePrefix}FiltroPoseeCuit`) || "Todos";
    const cookieIdTipoCierre = getCookie(`${cfg.cookiePrefix}FiltroIdTipoCierre`);
    const cookiePeriodoGestion = getCookie(`${cfg.cookiePrefix}FiltroPeriodoGestion`) || "";
    const cookieIdMotivoCualitativo = getCookie(`${cfg.cookiePrefix}FiltroIdMotivoCualitativo`);

    return {
      nombreSujeto: cookieNombreSujeto,
      identificacion: cookieIdentificacion,
      idOrganismo: cookieIdOrganismo ? parseInt(cookieIdOrganismo) : null,
      idCasoEstado: cookieIdCasoEstado ? parseInt(cookieIdCasoEstado) : null,
      idUsuario: cookieIdUsuario ? parseInt(cookieIdUsuario) : null,
      cantidadObjetosDesde: cookieCantObjetosDesde,
      cantidadObjetosHasta: cookieCantObjetosHasta,
      montoDesde: cookieMontoDesde,
      montoHasta: cookieMontoHasta,
      numeroCaso: cookieNumeroCaso,
      objetos: cookieObjetos,
      fechaEventoDesde: null,
      fechaEventoHasta: null,
      poseeContactos: cookiePoseeContactos,
      poseeCuit: cookiePoseeCuit,
      TipoCierre: cookieIdTipoCierre ? parseInt(cookieIdTipoCierre) : null,
      limiteRegistros: 100,
      periodoGestion: cookiePeriodoGestion ? cookiePeriodoGestion.split(",") : [],
      idMotivoCualitativo: cookieIdMotivoCualitativo ? parseInt(cookieIdMotivoCualitativo) : null
    };
  });
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [perfilActual, setPerfilActual] = useState({ limiteRegistros: 100, puedeReasignarCasos: false });
  const idUsuarioLogueado = parseInt(localStorage.getItem("iduserlogueado")) || 0;

  // El límite de registros lo define el perfil del usuario (pantalla Perfiles).
  useEffect(() => {
    fetchPerfilActual().then((perfil) => {
      setPerfilActual(perfil);
      setFilters((prev) => ({ ...prev, limiteRegistros: perfil.limiteRegistros }));
    });
  }, []);
  const [refreshKey, setRefreshKey] = useState(0);
  const [organismos, setOrganismos] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [estados, setEstados] = useState([]);
  const [estadosFiltrados, setEstadosFiltrados] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, msg: "", severity: "success" });
  const [expandedRows, setExpandedRows] = useState({});
  const [objetosDialog, setObjetosDialog] = useState({ open: false, contenido: "" });

  // Vincular Sujeto Real Dialog
  const [vincularDialog, setVincularDialog] = useState({
    open: false,
    idCaso: null,
    nombreSujetoCaso: "",
    identificacionCaso: "",
    sujetoRealVinculado: 0
  });
  const [vincularFilters, setVincularFilters] = useState({ nombre: "", identificacion: "", dni: "" });
  const [vincularValidationErrors, setVincularValidationErrors] = useState({ cuit: "", dni: "", both: "" });
  const [sujetosOptions, setSujetosOptions] = useState([]);
  const [selectedSujeto, setSelectedSujeto] = useState(null);
  const [loadingSujetos, setLoadingSujetos] = useState(false);
  const [vinculando, setVinculando] = useState(false);

  // Agenda Dialog
  const [agendaDialog, setAgendaDialog] = useState({
    open: false,
    idCaso: null,
    idSujeto: null,
    nombreSujeto: "",
    fecha: dayjs(),
    observaciones: ""
  });
  const [guardandoAgenda, setGuardandoAgenda] = useState(false);

  // Notificaciones Agenda
  const [agendasHoy, setAgendasHoy] = useState([]);
  const [agendasFiltradas, setAgendasFiltradas] = useState([]);
  const [agendasNoVistas, setAgendasNoVistas] = useState(0);
  const [notificacionesDialog, setNotificacionesDialog] = useState(false);
  const [loadingAgendas, setLoadingAgendas] = useState(false);
  const [agendaFilters, setAgendaFilters] = useState({
    fechaDesde: dayjs(),
    fechaHasta: dayjs(),
    nombreSujeto: ""
  });

  // Seguimiento Dialog
  const [seguimientoDialog, setSeguimientoDialog] = useState({
    open: false,
    idCaso: null,
    eventos: [],
    loading: false
  });

  // Mail Dialog
  const [mailDialog, setMailDialog] = useState({
    open: false,
    idCaso: null,
    para: "",
    cc: "",
    asunto: "",
    cuerpo: "",
    enviando: false
  });

  // Agregar Evento Dialog
  const [eventoDialog, setEventoDialog] = useState({
    open: false,
    idCaso: null,
    idCasoEstado: null,
    idSujeto: null,
    nombreSujeto: "",
    observaciones: "",
    tipoEvento: null,
    guardando: false,
    agendarLlamada: false,
    fechaAgenda: dayjs(),
    observacionesAgenda: ""
  });

  const [tiposEvento, setTiposEvento] = useState([]);

  const [observacionesExpandidas, setObservacionesExpandidas] = useState({});

  // Info Sujeto Vinculado Dialog
  // `nombreSujeto`/`tipoIdentificacion`/`identificacion` son los del sujeto real vinculado. `sujetoTempList` son las filas de la info
  // temporal (ver agruparProvisorios) y `nombresProvisorios` el nombre de cada sujeto provisorio por su ID. `sujetoProvisorio` es el que
  // traía el caso al vincularlo en esta sesión ({ idSujeto, nombre, tipoIdentificacion, identificacion }, o null si no se vinculó acá).
  const [infoSujetoDialog, setInfoSujetoDialog] = useState({
    open: false,
    idSujeto: null,
    nombreSujeto: "",
    tipoIdentificacion: "",
    identificacion: "",
    sujetoProvisorio: null,
    nombresProvisorios: {},
    sujetoTempList: [],
    loading: false,
    transfering: false
  });

  // Contactos Dialog
  const [contactosDialog, setContactosDialog] = useState({
    open: false,
    idSujeto: null,
    nombreSujeto: "",
    contactos: []
  });

  // Edit Contacto Dialog
  const [editContactoDialog, setEditContactoDialog] = useState({
    open: false,
    contacto: null,
    idSujeto: null,
    valorContacto: "",
    selectedTipo: null,
    selectedOrigen: null,
    selectedPrioridad: null,
    saving: false
  });

  // Add Contacto Dialog
  const [addContactoDialog, setAddContactoDialog] = useState({
    open: false,
    idSujeto: null,
    valorContacto: "",
    selectedTipo: null,
    selectedOrigen: null,
    selectedPrioridad: null,
    saving: false
  });

  // Delete Contacto Dialog
  const [deleteContactoDialog, setDeleteContactoDialog] = useState({
    open: false,
    idSujetoContacto: null
  });

  // Catálogos para contactos
  const [tiposContacto, setTiposContacto] = useState([]);
  const [origenesContacto, setOrigenesContacto] = useState([]);
  const [prioridadesContacto, setPrioridadesContacto] = useState([]);

  // Historial de Casos del Sujeto Dialog
  const [historialCasosDialog, setHistorialCasosDialog] = useState({
    open: false,
    idSujeto: null,
    nombreSujeto: "",
    casos: [],
    loading: false
  });

  // Cambiar Gestor Dialog
  const [cambiarGestorDialog, setCambiarGestorDialog] = useState({
    open: false,
    idCaso: null,
    idUsuarioActual: null,
    usuarioActual: "",
    selectedUsuario: null,
    guardando: false
  });

  // Exportar Excel Dialog
  const [exportarExcelDialog, setExportarExcelDialog] = useState({
    open: false,
    tipoReporte: "Resumido",
    exportando: false
  });

  const periodOptions = useMemo(() => {
    const meses = [
      "ENE",
      "FEB",
      "MAR",
      "ABR",
      "MAY",
      "JUN",
      "JUL",
      "AGO",
      "SEP",
      "OCT",
      "NOV",
      "DIC",
    ];
    const base = dayjs();
    const options = [];
    for (let i = -12; i <= 1; i += 1) {
      const date = base.add(i, "month");
      const year = date.year();
      const monthNumber = String(date.month() + 1).padStart(2, "0");
      const label = `${year}${monthNumber}-${meses[date.month()]}`;
      options.push({ value: label, label });
    }
    return options;
  }, []);

  const handleOpenObjetosDialog = (objetos) => {
    setObjetosDialog({ open: true, contenido: objetos });
  };

  const handleCloseObjetosDialog = () => {
    setObjetosDialog({ open: false, contenido: "" });
  };

  const handleOpenInfoSujeto = async (item) => {
    // El sujeto provisorio que traía el caso: si se vinculó en esta sesión, se guardó al vincular (sujetoProvisorioAnt).
    const provisorioGuardado = item.sujetoProvisorioAnt || null;
    setInfoSujetoDialog({
      open: true,
      idSujeto: item.idSujeto,
      nombreSujeto: item.nombreSujeto || "",
      tipoIdentificacion: item.tipoIdentificacion || "",
      identificacion: item.identificacion || "",
      sujetoProvisorio: provisorioGuardado,
      nombresProvisorios: {},
      sujetoTempList: [],
      loading: true,
      transfering: false
    });

    try {
      const response = await getData(`SujetoTempById/${item.idSujeto}`);
      if (response && response.isSuccess) {
        const lista = response.value || [];
        setInfoSujetoDialog(prev => ({
          ...prev,
          sujetoTempList: lista,
          loading: false
        }));
        // El nombre de cada provisorio no viene con la info temporal: se pide aparte (sin esto, solo se vería su identificación).
        const nombres = {};
        await Promise.all(agruparProvisorios(lista).map(async (p) => {
          try {
            const sujeto = await getData(`/SujetoGet/${p.idSujetoInventado}`);
            if (sujeto?.isSuccess && sujeto.value?.nombre) nombres[p.idSujetoInventado] = sujeto.value.nombre;
          } catch (ex) {
            console.error("No se pudo obtener el sujeto provisorio:", ex);
          }
        }));
        setInfoSujetoDialog(prev => ({ ...prev, nombresProvisorios: nombres }));
      } else {
        setInfoSujetoDialog(prev => ({
          ...prev,
          loading: false
        }));
        setSnackbar({
          open: true,
          msg: response?.error || "Error al cargar la información del sujeto",
          severity: "error"
        });
      }
    } catch (error) {
      setInfoSujetoDialog(prev => ({
        ...prev,
        loading: false
      }));
      setSnackbar({
        open: true,
        msg: "Error al cargar la información del sujeto",
        severity: "error"
      });
    }
  };

  const handleCloseInfoSujeto = () => {
    setInfoSujetoDialog({
      open: false,
      idSujeto: null,
      nombreSujeto: "",
      tipoIdentificacion: "",
      identificacion: "",
      sujetoProvisorio: null,
      sujetoTempList: [],
      loading: false,
      transfering: false
    });
  };

  // Recuadro con el sujeto provisorio (el que traía el caso antes de vincularlo) en la ventana de información del sujeto vinculado.
  const bloqueSujetoProvisorio = (nombre, tipoIdentificacion, identificacion) => (
    <MDBox mb={2} p={1.5} sx={{ bgcolor: 'grey.100', borderRadius: 1 }}>
      <MDTypography variant="caption" color="text" fontWeight="bold" display="block" mb={0.5}>
        Sujeto provisorio (el que traía el caso antes de vincularlo):
      </MDTypography>
      {nombre && (
        <MDTypography variant="body2" color="text" fontWeight="bold">
          {nombre}
        </MDTypography>
      )}
      <MDTypography variant="body2" color="text">
        {tipoIdentificacion || "N/A"} - {identificacion || "N/A"}
      </MDTypography>
    </MDBox>
  );

  // Lo que se muestra de los sujetos provisorios en la ventana de información del sujeto vinculado, debajo del sujeto real: un bloque por cada
  // provisorio vinculado, con sus contactos (que se pueden transferir al sujeto real) o la aclaración de que ya no tiene.
  const contenidoProvisorios = () => {
    const { sujetoTempList, nombresProvisorios, sujetoProvisorio, transfering } = infoSujetoDialog;
    const provisorios = agruparProvisorios(sujetoTempList);

    if (provisorios.length === 0) {
      // La base no tiene el detalle del provisorio: si el caso se vinculó en esta sesión, al menos se muestra el que traía.
      return (
        <MDBox>
          {sujetoProvisorio && bloqueSujetoProvisorio(sujetoProvisorio.nombre, sujetoProvisorio.tipoIdentificacion, sujetoProvisorio.identificacion)}
          <MDTypography variant="body2" color="text" fontStyle="italic">
            {sujetoProvisorio
              ? "No hay contactos del sujeto provisorio para transferir"
              : "No hay datos del sujeto provisorio registrados para este sujeto"}
          </MDTypography>
        </MDBox>
      );
    }

    return (
      <MDBox display="flex" flexDirection="column" gap={2}>
        {provisorios.map((p) => {
          const nombre = nombresProvisorios[p.idSujetoInventado] || (sujetoProvisorio?.idSujeto === p.idSujetoInventado ? sujetoProvisorio.nombre : "");
          return (
            <MDBox key={p.idSujetoInventado}>
              {bloqueSujetoProvisorio(nombre, p.tipoIdentificacion, p.identificacion)}

              {p.contactos.length > 0 ? (
                <MDBox>
                  <MDTypography variant="caption" color="text" fontWeight="bold" display="block" mb={1}>
                    Contactos:
                  </MDTypography>
                  <MDBox sx={{ border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden' }}>
                    <MDBox display="flex" sx={{ bgcolor: 'primary.main', color: 'white', p: 1.5 }}>
                      <MDBox flex={1}>
                        <MDTypography variant="caption" color="white" fontWeight="bold">
                          Tipo Contacto
                        </MDTypography>
                      </MDBox>
                      <MDBox flex={2}>
                        <MDTypography variant="caption" color="white" fontWeight="bold">
                          Contacto
                        </MDTypography>
                      </MDBox>
                      <MDBox width="80px" textAlign="center">
                        <MDTypography variant="caption" color="white" fontWeight="bold">
                          Acción
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                    {p.contactos.map((contacto, index) => (
                      <MDBox
                        key={contacto.idSujetoContacto}
                        display="flex"
                        sx={{
                          p: 1.5,
                          borderTop: index > 0 ? '1px solid #e0e0e0' : 'none',
                          '&:hover': { bgcolor: 'grey.50' }
                        }}
                      >
                        <MDBox flex={1} display="flex" alignItems="center">
                          <MDTypography variant="body2" color="text">
                            {contacto.tipoContacto || "N/A"}
                          </MDTypography>
                        </MDBox>
                        <MDBox flex={2} display="flex" alignItems="center">
                          <MDTypography variant="body2" color="text">
                            {contacto.contacto || "N/A"}
                          </MDTypography>
                        </MDBox>
                        <MDBox width="80px" display="flex" justifyContent="center" alignItems="center">
                          <Tooltip title="Transferir a contacto principal">
                            <MuiIconButton
                              size="small"
                              color="primary"
                              onClick={() => handleTransferirContacto(contacto.idSujetoContacto)}
                              disabled={transfering}
                            >
                              {transfering ? <CircularProgress size={20} /> : <SwapHoriz />}
                            </MuiIconButton>
                          </Tooltip>
                        </MDBox>
                      </MDBox>
                    ))}
                  </MDBox>
                </MDBox>
              ) : (
                <MDTypography variant="body2" color="text" fontStyle="italic">
                  Este sujeto provisorio no tiene contactos (nunca los tuvo o ya se transfirieron todos al sujeto real)
                </MDTypography>
              )}
            </MDBox>
          );
        })}
      </MDBox>
    );
  };

  const handleTransferirContacto = async (idSujetoContacto) => {
    setInfoSujetoDialog(prev => ({ ...prev, transfering: true }));

    try {
      const response = await postData('TransferirContactoPrincipal', {
        idSujetoContacto: idSujetoContacto,
        idSujeto: infoSujetoDialog.idSujeto
      });

      if (response && response.isSuccess) {
        setSnackbar({
          open: true,
          msg: "Contacto transferido exitosamente",
          severity: "success"
        });
        // Recargar los datos
        const refreshResponse = await getData(`SujetoTempById/${infoSujetoDialog.idSujeto}`);
        if (refreshResponse && refreshResponse.isSuccess) {
          setInfoSujetoDialog(prev => ({
            ...prev,
            sujetoTempList: refreshResponse.value || [],
            transfering: false
          }));
        } else {
          setInfoSujetoDialog(prev => ({ ...prev, transfering: false }));
        }
      } else {
        setInfoSujetoDialog(prev => ({ ...prev, transfering: false }));
        setSnackbar({
          open: true,
          msg: response.error || "Error al transferir el contacto",
          severity: "error"
        });
      }
    } catch (error) {
      setInfoSujetoDialog(prev => ({ ...prev, transfering: false }));
      setSnackbar({
        open: true,
        msg: "Error al transferir el contacto",
        severity: "error"
      });
    }
  };

  // Handlers para Contactos Dialog
  const handleOpenContactos = async (item) => {
    const contactos = item.sujetoContactos || [];
    // Ordenar: primero los que tienen prioridad (orden >= 0), luego los que no tienen (orden < 0)
    const sortedContactos = [...contactos].sort((a, b) => {
        const ordenA = a.orden ?? -1;
        const ordenB = b.orden ?? -1;

        // Si ambos tienen orden válido (>= 0), ordenar ascendente
        if (ordenA >= 0 && ordenB >= 0) return ordenA - ordenB;
        // Si solo A tiene orden válido, A va primero
        if (ordenA >= 0 && ordenB < 0) return -1;
        // Si solo B tiene orden válido, B va primero
        if (ordenA < 0 && ordenB >= 0) return 1;
        // Si ninguno tiene orden válido, mantener orden original
        return 0;
    });

    setContactosDialog({
      open: true,
      idSujeto: item.idSujeto || null,
      nombreSujeto: item.nombreSujeto || "",
      contactos: sortedContactos
    });
  };

  const handleCloseContactos = () => {
    setContactosDialog({
      open: false,
      idSujeto: null,
      nombreSujeto: "",
      contactos: []
    });
  };

  // Handlers para Edit Contacto
  const handleOpenEditContacto = async (contacto, idSujeto) => {
    try {
      // Preseleccionar valores con los catálogos ya cargados
      const preTipo = tiposContacto.find(x => x.id === contacto.idSujetoContactoTipo) || null;
      const preOrigen = origenesContacto.find(x => x.id === contacto.idSujetoContactoOrigen) || null;
      const prePrioridad = prioridadesContacto.find(x => x.id === contacto.idSujetoPrioridadContacto) || null;

      setEditContactoDialog({
        open: true,
        contacto: contacto,
        idSujeto: idSujeto,
        valorContacto: contacto.contacto || "",
        selectedTipo: preTipo,
        selectedOrigen: preOrigen,
        selectedPrioridad: prePrioridad,
        saving: false
      });
    } catch (ex) {
      console.error('Error cargando datos para editar contacto:', ex);
      setSnackbar({ open: true, msg: 'Error al cargar datos para editar', severity: 'error' });
    }
  };

  const handleCloseEditContacto = () => {
    setEditContactoDialog({
      open: false,
      contacto: null,
      idSujeto: null,
      valorContacto: "",
      selectedTipo: null,
      selectedOrigen: null,
      selectedPrioridad: null,
      saving: false
    });
  };

  // Handlers para Agregar Contacto
  const handleOpenAddContacto = (idSujeto) => {
    setAddContactoDialog({
      open: true,
      idSujeto: idSujeto,
      valorContacto: "",
      selectedTipo: null,
      selectedOrigen: null,
      selectedPrioridad: null,
      saving: false
    });
  };

  const handleCloseAddContacto = () => {
    setAddContactoDialog({
      open: false,
      idSujeto: null,
      valorContacto: "",
      selectedTipo: null,
      selectedOrigen: null,
      selectedPrioridad: null,
      saving: false
    });
  };

  const handleSaveAddContacto = async () => {
    const { idSujeto, valorContacto, selectedTipo, selectedOrigen, selectedPrioridad } = addContactoDialog;

    if (!valorContacto.trim()) {
      setSnackbar({ open: true, msg: 'El contacto no puede estar vacío', severity: 'warning' });
      return;
    }
    if (!selectedTipo) {
      setSnackbar({ open: true, msg: 'Debe seleccionar un tipo de contacto', severity: 'warning' });
      return;
    }
    if (!selectedOrigen) {
      setSnackbar({ open: true, msg: 'Debe seleccionar un origen', severity: 'warning' });
      return;
    }

    setAddContactoDialog(prev => ({ ...prev, saving: true }));

    try {
      const payload = {
        idSujetoContactoTipo: selectedTipo.id,
        idSujetoContactoOrigen: selectedOrigen.id,
        idSujetoPrioridadContacto: selectedPrioridad?.id || 0,
        idSujeto: idSujeto,
        contacto: valorContacto,
      };

      const res = await postData('/SujetoContactoAlta', payload);

      if (res?.isSuccess) {
        setSnackbar({ open: true, msg: 'Contacto agregado correctamente', severity: 'success' });

        // Crear el nuevo contacto con los datos devueltos por el API
        const newContacto = {
          idSujetoContacto: res.data?.idSujetoContacto || Date.now(),
          contacto: valorContacto,
          tipoContacto: selectedTipo.label,
          idSujetoContactoTipo: selectedTipo.id,
          origen: selectedOrigen.label,
          idSujetoContactoOrigen: selectedOrigen.id,
          prioridadNombre: selectedPrioridad?.label || null,
          idSujetoPrioridadContacto: selectedPrioridad?.id || 0
        };

        // Actualizar la lista de contactos en el diálogo
        setContactosDialog(prev => ({
          ...prev,
          contactos: [...prev.contactos, newContacto]
        }));

        // Actualizar rawData para que se refleje en la tabla principal
        setRawData(prevData => prevData.map(item => {
          if (item.idSujeto === idSujeto) {
            return {
              ...item,
              sujetoContactos: [...(item.sujetoContactos || []), newContacto]
            };
          }
          return item;
        }));

        handleCloseAddContacto();
      } else {
        setSnackbar({ open: true, msg: res?.error || 'Error agregando contacto', severity: 'error' });
      }
    } catch (ex) {
      console.error('Error agregando contacto:', ex);
      const errorMsg = ex?.message || ex?.response?.data?.detail || 'Error agregando contacto';
      setSnackbar({ open: true, msg: errorMsg, severity: 'error' });
    } finally {
      setAddContactoDialog(prev => ({ ...prev, saving: false }));
    }
  };

  const handleSaveEditContacto = async () => {
    const { contacto, idSujeto, valorContacto, selectedTipo, selectedOrigen, selectedPrioridad } = editContactoDialog;

    // Validar campos requeridos
    if (!selectedTipo) {
      setSnackbar({ open: true, msg: 'Debe seleccionar un tipo de contacto', severity: 'warning' });
      return;
    }

    if (!selectedOrigen) {
      setSnackbar({ open: true, msg: 'Debe seleccionar un origen', severity: 'warning' });
      return;
    }

    if (!valorContacto.trim()) {
      setSnackbar({ open: true, msg: 'El contacto no puede estar vacío', severity: 'warning' });
      return;
    }

    setEditContactoDialog(prev => ({ ...prev, saving: true }));

    try {
      const payload = {
        idSujetoContacto: contacto.idSujetoContacto,
        idSujetoContactoTipo: selectedTipo?.id || contacto.idSujetoContactoTipo,
        idSujetoContactoOrigen: selectedOrigen?.id || contacto.idSujetoContactoOrigen,
        idSujetoPrioridadContacto: selectedPrioridad?.id ?? 0,
        idSujeto: idSujeto,
        contacto: valorContacto,
      };

      const res = await pathData('/SujetoContactoUpdate', payload);

      if (res?.isSuccess) {
        setSnackbar({ open: true, msg: 'Contacto actualizado correctamente', severity: 'success' });

        // Actualizar la lista de contactos en el diálogo
        const updatedContactos = contactosDialog.contactos.map(c =>
          c.idSujetoContacto === contacto.idSujetoContacto
            ? {
              ...c,
              contacto: valorContacto,
              tipoContacto: selectedTipo?.label || c.tipoContacto,
              idSujetoContactoTipo: selectedTipo?.id || c.idSujetoContactoTipo,
              origen: selectedOrigen?.label || c.origen,
              idSujetoContactoOrigen: selectedOrigen?.id || c.idSujetoContactoOrigen,
              prioridadNombre: selectedPrioridad?.label || c.prioridadNombre,
              idSujetoPrioridadContacto: selectedPrioridad?.id || c.idSujetoPrioridadContacto
            }
            : c
        );
        setContactosDialog(prev => ({ ...prev, contactos: updatedContactos }));

        // Actualizar rawData para que se refleje en la tabla principal
        setRawData(prevData => prevData.map(item => {
          if (item.idSujeto === idSujeto) {
            return {
              ...item,
              sujetoContactos: item.sujetoContactos.map(c =>
                c.idSujetoContacto === contacto.idSujetoContacto
                  ? {
                    ...c,
                    contacto: valorContacto,
                    tipoContacto: selectedTipo?.label || c.tipoContacto,
                    idSujetoContactoTipo: selectedTipo?.id || c.idSujetoContactoTipo,
                    origen: selectedOrigen?.label || c.origen,
                    idSujetoContactoOrigen: selectedOrigen?.id || c.idSujetoContactoOrigen,
                    prioridadNombre: selectedPrioridad?.label || c.prioridadNombre,
                    idSujetoPrioridadContacto: selectedPrioridad?.id || c.idSujetoPrioridadContacto
                  }
                  : c
              )
            };
          }
          return item;
        }));

        handleCloseEditContacto();
      } else {
        setSnackbar({ open: true, msg: res?.error || 'Error actualizando contacto', severity: 'error' });
      }
    } catch (ex) {
      console.error('Error actualizando contacto:', ex);
      const errorMsg = ex?.message || ex?.response?.data?.detail || 'Error actualizando contacto';
      setSnackbar({ open: true, msg: errorMsg, severity: 'error' });
    } finally {
      setEditContactoDialog(prev => ({ ...prev, saving: false }));
    }
  };

  // Handlers para Delete Contacto
  const handleOpenDeleteContacto = (idSujetoContacto) => {
    setDeleteContactoDialog({
      open: true,
      idSujetoContacto: idSujetoContacto
    });
  };

  const handleCloseDeleteContacto = () => {
    setDeleteContactoDialog({
      open: false,
      idSujetoContacto: null
    });
  };

  const handleConfirmDeleteContacto = async () => {
    try {
      const res = await deleteData(`/SujetoContactoDelete/${deleteContactoDialog.idSujetoContacto}`);

      if (res?.isSuccess) {
        setSnackbar({ open: true, msg: 'Contacto eliminado correctamente', severity: 'success' });

        // Actualizar la lista de contactos en el diálogo
        const updatedContactos = contactosDialog.contactos.filter(c =>
          c.idSujetoContacto !== deleteContactoDialog.idSujetoContacto
        );
        setContactosDialog(prev => ({ ...prev, contactos: updatedContactos }));

        // Actualizar rawData para que se refleje en la tabla principal
        setRawData(prevData => prevData.map(item => {
          if (item.idSujeto === contactosDialog.idSujeto) {
            return {
              ...item,
              sujetoContactos: item.sujetoContactos.filter(c =>
                c.idSujetoContacto !== deleteContactoDialog.idSujetoContacto
              )
            };
          }
          return item;
        }));

        handleCloseDeleteContacto();
      } else {
        setSnackbar({ open: true, msg: res?.error || 'Error eliminando contacto', severity: 'error' });
      }
    } catch (ex) {
      console.error('Error eliminando contacto:', ex);
      const errorMsg = ex?.message || ex?.response?.data?.detail || 'Error eliminando contacto';
      setSnackbar({ open: true, msg: errorMsg, severity: 'error' });
    }
  };

  // Handlers para Historial de Casos
  const handleOpenHistorialCasos = async (idSujeto, nombreSujeto) => {
    setHistorialCasosDialog({
      open: true,
      idSujeto: idSujeto,
      nombreSujeto: nombreSujeto,
      casos: [],
      loading: true
    });

    try {
      const response = await postData(cfg.api.casosPorSujeto(idSujeto), {});
      const casos = response?.value || [];
      setHistorialCasosDialog(prev => ({ ...prev, casos, loading: false }));
    } catch (ex) {
      console.error('Error cargando historial de casos:', ex);
      setSnackbar({ open: true, msg: 'Error al cargar el historial de casos', severity: 'error' });
      setHistorialCasosDialog(prev => ({ ...prev, loading: false }));
    }
  };

  const handleCloseHistorialCasos = () => {
    setHistorialCasosDialog({
      open: false,
      idSujeto: null,
      nombreSujeto: "",
      casos: [],
      loading: false
    });
  };

  // Handlers para Cambiar Gestor
  const handleOpenCambiarGestor = (item) => {
    setCambiarGestorDialog({
      open: true,
      idCaso: item.idCaso,
      idUsuarioActual: item.idUsuario,
      usuarioActual: item.usuario,
      selectedUsuario: null,
      guardando: false
    });
  };

  const handleCloseCambiarGestor = () => {
    setCambiarGestorDialog({
      open: false,
      idCaso: null,
      idUsuarioActual: null,
      usuarioActual: "",
      selectedUsuario: null,
      guardando: false
    });
  };

  const handleAceptarCambiarGestor = async () => {
    if (!cambiarGestorDialog.selectedUsuario) {
      setSnackbar({ open: true, msg: "Debe seleccionar un gestor", severity: "warning" });
      return;
    }

    // Validar que no sea el mismo usuario
    if (cambiarGestorDialog.selectedUsuario.id === cambiarGestorDialog.idUsuarioActual) {
      setSnackbar({ open: true, msg: "El gestor seleccionado ya está asignado a este caso", severity: "warning" });
      return;
    }

    setCambiarGestorDialog(prev => ({ ...prev, guardando: true }));

    try {
      const payload = {
        idCaso: cambiarGestorDialog.idCaso,
        idUsuario: cambiarGestorDialog.selectedUsuario.id,
        usuarioAnterior: cambiarGestorDialog.usuarioActual,
        usuarioNew: cambiarGestorDialog.selectedUsuario.label,
        IDUsuarioActual: parseInt(localStorage.getItem("iduserlogueado")) || 0
      };

      const response = await pathData(cfg.api.actualizarGestor, payload);

      if (response?.isSuccess) {
        setSnackbar({ open: true, msg: "Gestor actualizado correctamente", severity: "success" });
        handleCloseCambiarGestor();
        // Recargar datos
        await fetchData(true, filters);
      } else {
        setSnackbar({ open: true, msg: response?.error || "Error al actualizar gestor", severity: "error" });
      }
    } catch (ex) {
      console.error("Error actualizando gestor:", ex);
      const errorMsg = ex?.message || "Error al actualizar gestor";
      setSnackbar({ open: true, msg: errorMsg, severity: "error" });
    } finally {
      setCambiarGestorDialog(prev => ({ ...prev, guardando: false }));
    }
  };

  const toggleRowExpansion = (idCaso) => {
    setExpandedRows(prev => ({
      ...prev,
      [idCaso]: !prev[idCaso]
    }));
  };

  const [rawData, setRawData] = useState([]);

  // Puntaje del Disparador de los casos que se ven (plan 3.2c): solo en Pre-Judicial. Todo usuario ve el número y la estrella de
  // prioritario, siempre (también con el Disparador apagado); solo los perfiles que pueden administrar el Disparador pueden
  // marcarla o quitarla. La columna Puntaje del Excel (en handleExportarExcel) también es para todos.
  const [puntajes, setPuntajes] = useState({});
  const [marcandoCaso, setMarcandoCaso] = useState(null);
  const muestraPuntaje = modo === "prejudicial";
  const puedeMarcarPrioritario = muestraPuntaje && !!perfilActual.puedeGestionarDisparador;
  // Un caso cerrado (cualquier cierre: igual deuda, cancelación total o parcial, incremento de deuda) es un estado final: muestra el
  // puntaje que tenga guardado, pero no se puntúa de nuevo ni se puede marcar como prioritario, así que no lleva estrella.
  const estaCerrado = (item) => (item.tipoCierre ?? 0) !== 0;

  useEffect(() => {
    const ids = rawData.map((item) => item.idCaso);
    if (!muestraPuntaje || ids.length === 0) {
      setPuntajes({});
      return undefined;
    }
    // Se descarta la respuesta de un pedido viejo: si cambia la lista mientras todavía llega, vale solo la última.
    let cancelado = false;
    puntajesDeCasos(ids)
      .then((porCaso) => { if (!cancelado) setPuntajes(porCaso); })
      .catch((ex) => {
        // Sin puntajes la pantalla funciona igual (por ejemplo, si todavía no se corrió el script de la base).
        console.error("Error cargando los puntajes:", ex);
        if (!cancelado) setPuntajes({});
      });
    return () => { cancelado = true; };
  }, [rawData, muestraPuntaje]);

  const handleTogglePrioritario = async (idCaso, prioritario) => {
    setMarcandoCaso(idCaso);
    try {
      const res = await postData("/CasoPrioritarioMarcar", { idCaso, prioritario });
      if (res?.isSuccess) {
        setPuntajes((prev) => ({ ...prev, [idCaso]: res.value }));
        setSnackbar({ open: true, msg: prioritario ? "Caso marcado como prioritario" : "Se quitó la marca de prioritario", severity: "success" });
      } else {
        setSnackbar({ open: true, msg: res?.error || "No se pudo cambiar la marca", severity: "error" });
      }
    } catch (ex) {
      setSnackbar({ open: true, msg: ex?.detail || ex?.message || "No se pudo cambiar la marca", severity: "error" });
    } finally {
      setMarcandoCaso(null);
    }
  };

  const fetchData = async (useFilters = true, currentFilters = null) => {
    setLoading(true);
    try {
      const effectiveFilters = currentFilters ?? filters;

      // Convertir poseeContactos a valor numérico: Si=1, No=0, Todos=-1
      let poseeContactosValor = -1;
      if (effectiveFilters.poseeContactos === "Si") poseeContactosValor = 1;
      else if (effectiveFilters.poseeContactos === "No") poseeContactosValor = 0;

      // Convertir poseeCuit a valor numérico: Si=1, No=0, Todos=-1
      let poseeCuitValor = -1;
      if (effectiveFilters.poseeCuit === "Si") poseeCuitValor = 1;
      else if (effectiveFilters.poseeCuit === "No") poseeCuitValor = 0;

      // TipoCierre se envía tal cual viene del filtro (null para Todos, o el valor numérico)
      const idTipoCierreValor = effectiveFilters.TipoCierre !== null && effectiveFilters.TipoCierre !== undefined ? effectiveFilters.TipoCierre : -1;

      const req = useFilters
        ? {
          nombreSujeto: effectiveFilters.nombreSujeto || "",
          identificacion: effectiveFilters.identificacion || "",
          idOrganismo: effectiveFilters.idOrganismo || 0,
          idCasoEstado: effectiveFilters.idCasoEstado || 0,
          idCasoEtapa: cfg.idCasoEtapa,
          idMotivoCualitativo: effectiveFilters.idMotivoCualitativo || 0,
          idUsuario: effectiveFilters.idUsuario || 0,
          cantidadObjetosDesde: effectiveFilters.cantidadObjetosDesde ? parseInt(effectiveFilters.cantidadObjetosDesde) : 0,
          cantidadObjetosHasta: effectiveFilters.cantidadObjetosHasta ? parseInt(effectiveFilters.cantidadObjetosHasta) : 0,
          montoDesde: effectiveFilters.montoDesde ? parseFloat(effectiveFilters.montoDesde) : 0,
          montoHasta: effectiveFilters.montoHasta ? parseFloat(effectiveFilters.montoHasta) : 0,
          idCaso: effectiveFilters.numeroCaso ? parseInt(effectiveFilters.numeroCaso) : 0,
          objetos: effectiveFilters.objetos || "",
          fechaEventoDesde: null,
          fechaEventoHasta: null,
          poseeContactos: poseeContactosValor,
          poseeCuit: poseeCuitValor,
          TipoCierre: idTipoCierreValor,
          limiteRegistros: effectiveFilters.limiteRegistros || 100,
          periodoGestion: (effectiveFilters.periodoGestion || []).join(",")
        }
        : { nombreSujeto: "", identificacion: "", idOrganismo: 0, idCasoEstado: 0, idCasoEtapa: cfg.idCasoEtapa, idMotivoCualitativo: 0, idUsuario: 0, cantidadObjetosDesde: 0, cantidadObjetosHasta: 0, montoDesde: 0, montoHasta: 0, numeroCaso: 0, objetos: "", fechaEventoDesde: null, fechaEventoHasta: null, poseeContactos: -1, poseeCuit: -1, TipoCierre: 0, limiteRegistros: 100, periodoGestion: "" };

      const response = await postData(cfg.api.listar, req);
      const list = response?.value || [];
      setRawData(list);
      return list;
    } catch (ex) {
      console.error("Error cargando Casos:", ex);
      setError(ex);
      setSnackbar({ open: true, msg: "Error al cargar los casos", severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  // ---- Disparador Automático de Gestiones (plan 3.2d, paso 3): solo en Gestión Pre-Judicial ----
  // La propuesta (qué caso le asignó el sistema al gestor y en qué estado está) vive en el backend; acá solo se la refleja.
  // ACTIVA: se ve únicamente el caso asignado y los filtros quedan bloqueados. PAUSADA: filtros libres y un aviso fijo.
  const usaDisparador = modo === "prejudicial";
  const [propuesta, setPropuesta] = useState(null);
  const [propuestaError, setPropuestaError] = useState(null);
  const [procesandoPropuesta, setProcesandoPropuesta] = useState(false);
  const propuestaActiva = usaDisparador && propuesta?.estado === "ACTIVA";

  // Muestra en la grilla únicamente el caso asignado, sin tocar los filtros que el gestor tenía cargados.
  const cargarCasoPropuesto = async (idCaso) => {
    await fetchData(true, {
      nombreSujeto: "", identificacion: "", idOrganismo: null, idCasoEstado: null, idUsuario: null,
      cantidadObjetosDesde: "", cantidadObjetosHasta: "", montoDesde: "", montoHasta: "", numeroCaso: String(idCaso),
      objetos: "", poseeContactos: "Todos", poseeCuit: "Todos", TipoCierre: null,
      limiteRegistros: filters.limiteRegistros || 100, periodoGestion: [], idMotivoCualitativo: null
    });
  };

  // Llama a uno de los endpoints de la propuesta (Actual, Pedir, Pausar o Retomar) y deja la pantalla como corresponde.
  const ejecutarPropuesta = async (ruta) => {
    setProcesandoPropuesta(true);
    // Si el gestor tenía un caso asignado, la grilla lo está mostrando. Cuando ya no lo tiene y el sistema no tiene otro para
    // proponerle, hay que vaciarla: si no, parecería que el sistema le volvió a dar el mismo caso.
    const teniaAsignado = propuestaActiva;
    try {
      const res = await postData(ruta, {});
      const estado = res?.value ?? null;
      setPropuesta(estado);
      setPropuestaError(null);
      if (estado?.estado === "ACTIVA" && estado.propuesta) await cargarCasoPropuesto(estado.propuesta.idCaso);
      else if (teniaAsignado && estado?.disparadorActivo !== false && estado?.estado !== "PAUSADA") setRawData([]);
    } catch (ex) {
      // El Disparador no tiene que impedir trabajar: si falla, la pantalla funciona como siempre y se muestra el motivo.
      console.error("Error consultando el Disparador:", ex);
      setPropuestaError(ex?.detail || ex?.message || "error desconocido");
    } finally {
      setProcesandoPropuesta(false);
    }
  };

  useEffect(() => {
    if (usaDisparador) ejecutarPropuesta("/CasoPropuestaActual");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (rawData.length === 0) {
      setRows([]);
      setColumns([]);
      setCurrentTablePage(0);
      return;
    }

    const data = rawData.map((item) => {
      const isExpanded = expandedRows[item.idCaso];

      const casoInfo = (
        <MDBox>
          <MDBox display="flex" alignItems="center" gap={1} mb={1}>
            <MDTypography variant="h6" color="text" fontWeight="medium">
              Caso #{item.idCaso}
            </MDTypography>
          </MDBox>

          {muestraPuntaje && (
            <PuntajeCaso
              puntaje={puntajes[item.idCaso]}
              puedeMarcar={puedeMarcarPrioritario}
              cerrado={estaCerrado(item)}
              ocupado={marcandoCaso === item.idCaso}
              onTogglePrioritario={(marcar) => handleTogglePrioritario(item.idCaso, marcar)}
            />
          )}

          <MDBox ml={4}>
            <MDTypography variant="caption" color="info" fontWeight="bold" display="block">
              Organismo: {item.organismo}
            </MDTypography>
            <MDTypography variant="caption" color="warning" fontWeight="bold" display="block" mt={0.3}>
              Estado de la Gestión: {item.estado || 'N/A'}
            </MDTypography>
            {cfg.usaMotivo && (
              <MDTypography variant="caption" color="dark" fontWeight="bold" display="block" mt={0.3}>
                Motivo: {item.motivo || 'N/A'}
              </MDTypography>
            )}
            <MDTypography variant="caption" color="text" fontWeight="medium" display="block" mt={0.5} sx={{ whiteSpace: 'pre-wrap' }}>
              {(() => {
                if (!item.objetos) {
                  return `Objetos (${item.cantidadObjetos}): `;
                }

                const objetosFormateados = item.objetos.replace(/,(?=\S)/g, ', ');
                const tieneResumen = objetosFormateados.length > 50;
                const textoObjetos = tieneResumen ? `${objetosFormateados.substring(0, 50)}...` : objetosFormateados;

                if (!tieneResumen) {
                  return `Objetos (${item.cantidadObjetos}): ${textoObjetos}`;
                }

                return (
                  <Link
                    component="button"
                    type="button"
                    underline="hover"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenObjetosDialog(item.objetos);
                    }}
                    sx={{
                      color: 'info.main',
                      fontSize: 'inherit',
                      fontWeight: 'inherit',
                      textAlign: 'left',
                      verticalAlign: 'baseline',
                      '&:hover': {
                        color: 'info.main'
                      },
                      '&:visited': {
                        color: 'info.main'
                      }
                    }}
                  >
                    {`Objetos (${item.cantidadObjetos}): ${textoObjetos}`}
                  </Link>
                );
              })()}
            </MDTypography>
            {cfg.permiteVincular && (
              <MDBox display="flex" alignItems="center" gap={0.5} mt={0.5}>
                <MDTypography variant="caption" color="info" fontWeight="bold">
                  Vinculacion: {item.sujetoRealVinculado == 1 ? "Sujeto Vinculado" : "Caso sin vincular Sujeto Real"}
                </MDTypography>
                {item.sujetoRealVinculado == 1 ? (
                  <MuiIconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenInfoSujeto(item);
                    }}
                    sx={{ padding: 0, color: 'info.main' }}
                  >
                    <InfoOutlined sx={{ fontSize: 16 }} />
                  </MuiIconButton>
                ) : (
                  <MuiIconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleTraspasar(item.idCaso);
                    }}
                    sx={{ padding: '2px', color: 'secondary.main' }}
                    title="Vincular Sujeto Real"
                  >
                    <PersonCheck size={16} />
                  </MuiIconButton>
                )}
              </MDBox>
            )}
            <MDTypography variant="caption" color="success" fontWeight="bold" display="block" mt={0.5}>
              Monto: ${item.monto?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </MDTypography>
            {item.tipoCierreDescripcion && item.tipoCierreDescripcion !== 'SIN CERRAR' && (
              <MDBox
                mt={0.5}
                p={0.5}
                sx={{
                  backgroundColor: 'rgba(33, 150, 243, 0.1)',
                  border: '1px solid #2196f3',
                  borderRadius: 1,
                  display: 'inline-block'
                }}
              >
                <MDTypography variant="caption" color="info" fontWeight="bold">
                  Estado de Cierre: {item.tipoCierreDescripcion}
                </MDTypography>
              </MDBox>
            )}
          </MDBox>
        </MDBox>
      );

      const sujetoInfo = (
        <MDBox>
          <MDBox display="flex" alignItems="center" gap={1}>
            <MDTypography variant="body" color="dark" fontWeight="bold" sx={{ color: '#000000' }}>
              {item.nombreSujeto}
            </MDTypography>

            {/* Mostrar icono de contactos con badge si tiene contactos, sino mostrar botón agregar */}
            {item.sujetoContactos && item.sujetoContactos.length > 0 ? (
              <MDBox
                display="flex"
                alignItems="center"
                gap={0.5}
                sx={{
                  cursor: 'pointer',
                  padding: '4px 8px',
                  borderRadius: 1,
                  backgroundColor: 'rgba(25, 118, 210, 0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.2)',
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenContactos(item);
                }}
              >
                <Phone sx={{ fontSize: 16, color: 'info.main' }} />
                <Badge
                  badgeContent={item.sujetoContactos.length}
                  color="primary"
                  sx={{
                    '& .MuiBadge-badge': {
                      position: 'relative',
                      transform: 'none',
                      fontSize: '0.65rem',
                      height: '16px',
                      minWidth: '16px',
                      fontWeight: 'bold'
                    }
                  }}
                >
                  <span />
                </Badge>
              </MDBox>
            ) : (
              <MDBox
                display="flex"
                alignItems="center"
                gap={0.3}
                sx={{
                  cursor: 'pointer',
                  padding: '2px 6px',
                  borderRadius: 1,
                  backgroundColor: 'rgba(76, 175, 80, 0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(76, 175, 80, 0.2)',
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenAddContacto(item.idSujeto);
                }}
                title="Agregar contacto"
              >
                <Phone sx={{ fontSize: 16, color: 'success.main' }} />
                <Add sx={{ fontSize: 12, color: 'success.main' }} />
              </MDBox>
            )}

            <WhatsAppCaso item={item} />

            {cfg.permiteCasosDelSujeto && (
            <MDBox
              display="flex"
              alignItems="center"
              gap={0.3}
              sx={{
                cursor: 'pointer',
                padding: '2px 6px',
                borderRadius: 1,
                backgroundColor: 'rgba(156, 39, 176, 0.1)',
                '&:hover': {
                  backgroundColor: 'rgba(156, 39, 176, 0.2)',
                }
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleOpenHistorialCasos(item.idSujeto, item.nombreSujeto);
              }}
            >
              <History sx={{ fontSize: 16, color: 'secondary.main' }} />
            </MDBox>
            )}
          </MDBox>
          <MDTypography variant="body" color="dark" fontWeight="bold" display="block" sx={{ color: '#000000' }}>
            {item.tipoIdentificacion}: {item.identificacion}
          </MDTypography>
        </MDBox>
      );

      const usuarioInfo = (
        <MDBox display="flex" alignItems="center" gap={1}>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {item.usuario}
          </MDTypography>
          {(item.idUsuario === idUsuarioLogueado || perfilActual.puedeReasignarCasos) && (
            <MuiIconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenCambiarGestor(item);
              }}
              sx={{ padding: 0, color: 'info.main' }}
              title="Cambiar gestor"
            >
              <PersonGear size={16} />
            </MuiIconButton>
          )}
        </MDBox>
      );

      const isExcluido = item.idCasoEstado === 14;

      const acciones = (
        <MDBox display="flex" flexDirection="column" gap={0.5}>
          {(!item.tipoCierreDescripcion || item.tipoCierreDescripcion === 'SIN CERRAR') && (
            <MDButton
              variant="outlined"
              color="warning"
              size="small"
              startIcon={<PersonCheck size={14} />}
              fullWidth
              onClick={() => handleAgregarEvento(item.idCaso)}
            >
              Agregar Evento
            </MDButton>
          )}

          <MDButton
            variant="outlined"
            color="success"
            size="small"
            startIcon={<ListTask size={14} />}
            fullWidth
            onClick={() => handleSeguimiento(item.idCaso)}
          >
            Seguimiento
          </MDButton>

          <MDButton
            variant="outlined"
            color="info"
            size="small"
            startIcon={<CalendarEvent size={14} />}
            fullWidth
            onClick={() => handleOpenAgenda(item.idCaso, item.nombreSujeto)}
          >
            Ver Agenda
          </MDButton>
        </MDBox>
      );

      const fechaVencimiento = (() => {
        if (!item.fechaVencimiento) {
          return (
            <MDTypography variant="caption" color="text" fontWeight="medium">
              Sin fecha
            </MDTypography>
          );
        }

        const fechaVenc = dayjs(item.fechaVencimiento);
        const hoy = dayjs();
        const diasDiferencia = fechaVenc.diff(hoy, 'day');

        let icono = null;
        let colorIcono = "";
        let tooltipText = "";

        if (diasDiferencia < 0) {
          // Vencido
          icono = <Error sx={{ fontSize: 18 }} />;
          colorIcono = "error";
          tooltipText = `Vencido hace ${Math.abs(diasDiferencia)} día${Math.abs(diasDiferencia) !== 1 ? 's' : ''}`;
        } else if (diasDiferencia <= 7) {
          // Próximo a vencer (7 días o menos)
          icono = <Warning sx={{ fontSize: 18 }} />;
          colorIcono = "warning";
          tooltipText = diasDiferencia === 0
            ? "Vence hoy"
            : `Vence en ${diasDiferencia} día${diasDiferencia !== 1 ? 's' : ''}`;
        } else {
          // Más de 7 días
          icono = <CheckCircle sx={{ fontSize: 18 }} />;
          colorIcono = "success";
          tooltipText = `Vence el ${fechaVenc.format('DD/MM/YYYY')}`;
        }

        return (
          <MDBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {fechaVenc.format('DD/MM/YYYY')}
            </MDTypography>
            <Tooltip title={tooltipText} arrow>
              <MDBox display="flex" alignItems="center" sx={{ color: `${colorIcono}.main` }}>
                {icono}
              </MDBox>
            </Tooltip>
          </MDBox>
        );
      })();

      return {
        id: item.idCaso, // Agregar ID único para que React mantenga la identidad de la fila
        casoInfo,
        sujetoInfo,
        usuarioInfo,
        fechaVencimiento,
        acciones,
        backgroundColor: item.tipoCierreDescripcion && item.tipoCierreDescripcion !== 'SIN CERRAR'
          ? 'rgba(255, 165, 0, 0.15)' // Marco naranja suave para casos cerrados
          : (item.idCasoEstado === 14 ? 'rgba(255, 255, 0, 0.5)' : 'transparent'), // Marco amarillo brillante para estado 14
        borderLeft: item.tipoCierreDescripcion && item.tipoCierreDescripcion !== 'SIN CERRAR'
          ? '4px solid rgba(255, 165, 0, 0.8)' 
          : (item.idCasoEstado === 14 ? '5px solid rgba(255, 200, 0, 1)' : 'none')
      };
    });

    setRows(data);
    setColumns([
      { Header: "Caso", accessor: "casoInfo", align: "left", width: "30%" },
      { Header: "Sujeto", accessor: "sujetoInfo", align: "left", width: "20%" },
      { Header: "Gestor", accessor: "usuarioInfo", align: "left", width: "12%" },
      { Header: "F. Vencimiento", accessor: "fechaVencimiento", align: "center", width: "13%" },
      { Header: "Acciones", accessor: "acciones", align: "center", width: "25%" },
    ]);
  }, [rawData, expandedRows, puntajes, marcandoCaso, muestraPuntaje, puedeMarcarPrioritario]);

  useEffect(() => {
    // NO cargar casos automáticamente, solo agendas
    cargarAgendasHoy();

    // Recargar agendas cada 5 minutos
    const interval = setInterval(() => {
      cargarAgendasHoy();
    }, 300000); // 5 minutos

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const loadOrganismos = async () => {
      try {
        const data = await fetchOrganismos();
        setOrganismos(data.map(o => ({ id: o.idOrganismo, label: o.descripcion, activo: o.activo })));
      } catch (ex) {
        console.error("Error cargando organismos:", ex);
      }
    };
    loadOrganismos();
  }, []);

  useEffect(() => {
    const loadEtapas = async () => {
      try {
        const data = await fetchCasoEtapas();
        setEtapas(data.map(e => ({ id: e.idCasoEtapa, label: e.descripcion, activo: e.activo })));
      } catch (ex) {
        console.error("Error cargando etapas:", ex);
      }
    };
    loadEtapas();
  }, []);

  useEffect(() => {
    const loadEstados = async () => {
      try {
        const data = await cfg.fetchEstados();
        // Filtrar solo estados con IdEtapa === 1
        const estadosFiltrados = data
          .filter(e => e.idCasoEtapa === cfg.idCasoEtapa)
          .map(e => ({ id: e.idCasoEstado, idCasoEtapa: e.idCasoEtapa, label: e.descripcion, activo: e.activo }));
        setEstados(estadosFiltrados);
        setEstadosFiltrados(estadosFiltrados);
      } catch (ex) {
        console.error("Error cargando estados:", ex);
      }
    };
    loadEstados();
  }, []);

  useEffect(() => {
    const loadUsuarios = async () => {
      try {
        const data = await fetchUsuarios();
        setUsuarios(data.map(u => ({ id: u.idUsuario, label: u.nombreCompleto || u.usuario, activo: u.activo })));

        // Set default usuario from localStorage solo si NO es perfil 1 (Admin)
        const loggedUserId = parseInt(localStorage.getItem("idUsuario") || "0");
        const loggedUserPerfil = parseInt(localStorage.getItem("idPerfil") || "0");

        // Si ya tiene valor en cookie, usar ese
        const cookieIdUsuario = getCookie(`${cfg.cookiePrefix}FiltroIdUsuario`);
        if (cookieIdUsuario) {
          setFilters(prev => ({ ...prev, idUsuario: parseInt(cookieIdUsuario) }));
        } else if (loggedUserPerfil !== 1 && loggedUserId > 0) {
          // Solo precargar con usuario logueado si NO es perfil 1
          setFilters(prev => ({ ...prev, idUsuario: loggedUserId }));
        }
      } catch (ex) {
        console.error("Error cargando usuarios:", ex);
      }
    };
    loadUsuarios();
  }, []);

  // Cargar catálogos de contactos una sola vez al inicio
  useEffect(() => {
    const loadCatalogosContactos = async () => {
      try {
        const tipos = await fetchSujetoContactoTipos();
        const origenes = await fetchSujetoContactoOrigenes();
        const prioridades = await fetchSujetoContactoPrioridades();

        const tiposList = (tipos || []).map(t => ({ id: t.idSujetoContactoTipo, label: t.descripcion, activo: t.activo }));
        const origenesList = (origenes || []).map(o => ({ id: o.idSujetoContactoOrigen, label: o.descripcion, activo: o.activo }));
        const prioridadesList = (prioridades || []).map(p => ({ id: p.idSujetoPrioridadContacto, label: p.descripcion, activo: p.activo }));

        setTiposContacto(tiposList);
        setOrigenesContacto(origenesList);
        setPrioridadesContacto(prioridadesList);
      } catch (ex) {
        console.error('Error cargando catálogos de contactos:', ex);
      }
    };
    loadCatalogosContactos();
  }, []);



  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleOrganismoChange = (event, newValue) => {
    setFilters({ ...filters, idOrganismo: newValue?.id || null });
  };

  const handleEstadoChange = (event, newValue) => {
    setFilters({ ...filters, idCasoEstado: newValue?.id || null });
  };

  const handleUsuarioChange = (event, newValue) => {
    setFilters({ ...filters, idUsuario: newValue?.id || null });
  };

  // Motivos de campaña (solo gestión cualitativa).
  const [motivos, setMotivos] = useState([]);
  useEffect(() => {
    if (cfg.usaMotivo) fetchMotivosCualitativos(false).then(setMotivos);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMotivoChange = (event, newValue) => {
    setFilters({ ...filters, idMotivoCualitativo: newValue?.idMotivoCualitativo || null });
  };

  const handlePeriodoGestionChange = (event, newValue) => {
    setFilters({ ...filters, periodoGestion: (newValue || []).map((p) => p.value) });
  };

  const handlePoseeContactosChange = (event, newValue) => {
    setFilters({ ...filters, poseeContactos: newValue || "Todos" });
  };

  const handlePoseeCuitChange = (event, newValue) => {
    setFilters({ ...filters, poseeCuit: newValue || "Todos" });
  };

  const handleIdTipoCierreChange = (event, newValue) => {
    const selectedOption = cfg.tiposCierre.find(opt => opt.label === newValue);
    setFilters({ ...filters, TipoCierre: selectedOption ? selectedOption.value : null });
  };

  const handleSearch = async () => {
    // El período es opcional: sin elegir ninguno se buscan los casos de todos los períodos (el tope de registros del
    // perfil sigue aplicando).
    // Guardar filtros en cookies (válidas por 30 días = 43200 minutos)
    setCookie(`${cfg.cookiePrefix}FiltroNombreSujeto`, filters.nombreSujeto, 43200);
    setCookie(`${cfg.cookiePrefix}FiltroIdentificacion`, filters.identificacion, 43200);
    setCookie(`${cfg.cookiePrefix}FiltroIdOrganismo`, filters.idOrganismo || "", 43200);
    setCookie(`${cfg.cookiePrefix}FiltroIdCasoEstado`, filters.idCasoEstado || "", 43200);
    setCookie(`${cfg.cookiePrefix}FiltroIdUsuario`, filters.idUsuario || "", 43200);
    setCookie(`${cfg.cookiePrefix}FiltroCantObjetosDesde`, filters.cantidadObjetosDesde, 43200);
    setCookie(`${cfg.cookiePrefix}FiltroCantObjetosHasta`, filters.cantidadObjetosHasta, 43200);
    setCookie(`${cfg.cookiePrefix}FiltroMontoDesde`, filters.montoDesde, 43200);
    setCookie(`${cfg.cookiePrefix}FiltroMontoHasta`, filters.montoHasta, 43200);
    setCookie(`${cfg.cookiePrefix}FiltroNumeroCaso`, filters.numeroCaso, 43200);
    setCookie(`${cfg.cookiePrefix}FiltroObjetos`, filters.objetos, 43200);
    setCookie(`${cfg.cookiePrefix}FiltroPoseeContactos`, filters.poseeContactos, 43200);
    setCookie(`${cfg.cookiePrefix}FiltroPoseeCuit`, filters.poseeCuit, 43200);
    setCookie(`${cfg.cookiePrefix}FiltroIdTipoCierre`, filters.TipoCierre !== null ? filters.TipoCierre : "", 43200);
    setCookie(`${cfg.cookiePrefix}FiltroPeriodoGestion`, (filters.periodoGestion || []).join(","), 43200);
    setCookie(`${cfg.cookiePrefix}FiltroIdMotivoCualitativo`, filters.idMotivoCualitativo || "", 43200);
    sessionStorage.removeItem(cfg.tablaStorage);
    await fetchData(true, filters);
    //setRefreshKey(prev => prev + 1); // Resetear paginación al hacer nueva búsqueda
  };

  const handleClear = async () => {
    // Limpiar cookies
    setCookie(`${cfg.cookiePrefix}FiltroNombreSujeto`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroIdentificacion`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroIdOrganismo`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroIdCasoEstado`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroIdUsuario`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroCantObjetosDesde`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroCantObjetosHasta`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroMontoDesde`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroMontoHasta`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroNumeroCaso`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroObjetos`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroPoseeContactos`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroPoseeCuit`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroIdTipoCierre`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroPeriodoGestion`, "", -1);
    setCookie(`${cfg.cookiePrefix}FiltroIdMotivoCualitativo`, "", -1);

    const loggedUserId = parseInt(localStorage.getItem("idUsuario") || "0");
    const loggedUserPerfil = parseInt(localStorage.getItem("idPerfil") || "0");

    setFilters({
      nombreSujeto: "",
      identificacion: "",
      idOrganismo: null,
      idCasoEstado: null,
      idUsuario: (loggedUserPerfil !== 1 && loggedUserId > 0) ? loggedUserId : null,
      cantidadObjetosDesde: "",
      cantidadObjetosHasta: "",
      montoDesde: "",
      montoHasta: "",
      numeroCaso: "",
      objetos: "",
      fechaEventoDesde: null,
      fechaEventoHasta: null,
      poseeContactos: "Todos",
      poseeCuit: "Todos",
      TipoCierre: null,
      limiteRegistros: perfilActual.limiteRegistros,
      periodoGestion: [],
      idMotivoCualitativo: null
    });
    setRawData([]);
  };

  const handleOpenExportarExcel = () => {
    if (rawData.length === 0) {
      setSnackbar({ open: true, msg: "No hay datos para exportar", severity: "warning" });
      return;
    }
    setExportarExcelDialog({ open: true, tipoReporte: "Resumido", exportando: false });
  };

  const handleCloseExportarExcel = () => {
    if (!exportarExcelDialog.exportando) {
      setExportarExcelDialog({ open: false, tipoReporte: "Resumido", exportando: false });
    }
  };

  const handleExportarExcel = async () => {
    try {
      setExportarExcelDialog(prev => ({ ...prev, exportando: true }));

      // Si es reporte detallado, obtener datos del endpoint CasoAntListar
      let dataParaReporte = rawData;
      if (exportarExcelDialog.tipoReporte === "Detallado") {
        try {
          // Convertir poseeContactos a valor numérico: Si=1, No=0, Todos=-1
          let poseeContactosValor = -1;
          if (filters.poseeContactos === "Si") poseeContactosValor = 1;
          else if (filters.poseeContactos === "No") poseeContactosValor = 0;

          // Convertir poseeCuit a valor numérico: Si=1, No=0, Todos=-1
          let poseeCuitValor = -1;
          if (filters.poseeCuit === "Si") poseeCuitValor = 1;
          else if (filters.poseeCuit === "No") poseeCuitValor = 0;

          const idTipoCierreValor = filters.TipoCierre !== null && filters.TipoCierre !== undefined ? filters.TipoCierre : -1;

          const req = {
            nombreSujeto: filters.nombreSujeto || "",
            identificacion: filters.identificacion || "",
            idOrganismo: filters.idOrganismo || 0,
            idCasoEstado: filters.idCasoEstado || 0,
            idCasoEtapa: cfg.idCasoEtapa,
            idMotivoCualitativo: filters.idMotivoCualitativo || 0,
            idUsuario: filters.idUsuario || 0,
            cantidadObjetosDesde: filters.cantidadObjetosDesde ? parseInt(filters.cantidadObjetosDesde) : 0,
            cantidadObjetosHasta: filters.cantidadObjetosHasta ? parseInt(filters.cantidadObjetosHasta) : 0,
            montoDesde: filters.montoDesde ? parseFloat(filters.montoDesde) : 0,
            montoHasta: filters.montoHasta ? parseFloat(filters.montoHasta) : 0,
            idCaso: filters.numeroCaso ? parseInt(filters.numeroCaso) : 0,
            objetos: filters.objetos || "",
            fechaEventoDesde: null,
            fechaEventoHasta: null,
            poseeContactos: poseeContactosValor,
            poseeCuit: poseeCuitValor,
            TipoCierre: idTipoCierreValor,
            limiteRegistros: filters.limiteRegistros || 100,
            periodoGestion: (filters.periodoGestion || []).join(",")
          };

          const response = await postData(cfg.api.listarDetallado, req);
          dataParaReporte = response?.value || [];

          if (dataParaReporte.length === 0) {
            setSnackbar({ open: true, msg: "No hay datos para exportar", severity: "warning" });
            setExportarExcelDialog(prev => ({ ...prev, exportando: false }));
            return;
          }
        } catch (ex) {
          console.error("Error obteniendo datos del reporte detallado:", ex);
          setSnackbar({ open: true, msg: "Error al obtener los datos del reporte", severity: "error" });
          setExportarExcelDialog(prev => ({ ...prev, exportando: false }));
          return;
        }
      }

      // Puntaje del Disparador (solo Pre-Judicial). Si no se puede consultar, el reporte sale igual y se avisa al final.
      let puntajesExcel = {};
      let puntajesDisponibles = true;
      if (modo === "prejudicial") {
        try {
          puntajesExcel = await puntajesDeCasos(dataParaReporte.map((item) => item.idCaso));
        } catch (ex) {
          console.error("Error obteniendo los puntajes para el reporte:", ex);
          puntajesDisponibles = false;
        }
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Casos');

      // Definir columnas según el tipo de reporte
      if (exportarExcelDialog.tipoReporte === "Resumido") {
        worksheet.columns = [
          { header: 'USUARIO ASIGNADO', key: 'usuario', width: 25 },
          { header: 'ORGANISMO', key: 'organismo', width: 35 },
          { header: 'N° de CASO', key: 'numeroCaso', width: 12 },
          { header: 'FECHA DE NACIMIENTO DEL CASO', key: 'fechaNacimiento', width: 25 },
          { header: 'PERIODO DE GESTION', key: 'periodoGestion', width: 20 },
          { header: 'TIPO DE IDENTIFICACIÓN', key: 'tipoIdentificacion', width: 20 },
          { header: 'IDENTIFICACIÓN', key: 'identificacion', width: 18 },
          { header: 'NOMBRE DEL SUJETO', key: 'nombreSujeto', width: 35 },
          { header: 'CANTIDAD DE OBJETOS INICIO', key: 'cantidadObjetosInicio', width: 25 },
          { header: 'CANTIDAD DE OBJETOS FINAL', key: 'cantidadObjetosFinal', width: 25 },
          { header: 'OBJETOS', key: 'objetos', width: 80 },
          { header: 'MONTO INICIO', key: 'montoInicio', width: 18 },
          { header: 'MONTO FINAL', key: 'montoFinal', width: 18 },
          { header: 'DIFERENCIA DE MONTO', key: 'diferenciaMonto', width: 18 },
          { header: 'ÚLTIMO ESTADO', key: 'ultimoEstado', width: 20 },
          { header: 'ÚLTIMO EVENTO', key: 'ultimoEvento', width: 30 },
          { header: 'FECHA ÚLTIMO EVENTO', key: 'fechaUltimoEvento', width: 16 },
          { header: 'HORA ÚLTIMO EVENTO', key: 'horaUltimoEvento', width: 14 },
          { header: 'ESTADO CIERRE', key: 'estadoCierre', width: 20 },
          ...(cfg.usaMotivo ? [{ header: 'MOTIVO DE LA CAMPAÑA', key: 'motivo', width: 35 }] : []),
          ...(modo === "prejudicial" ? [{ header: 'PUNTAJE', key: 'puntaje', width: 12 }] : [])
        ];
      } else {
        // Detallado con contactos, objetos y datos de caso anterior
        worksheet.columns = [
          { header: 'USUARIO ASIGNADO', key: 'usuario', width: 25 },
          { header: 'ORGANISMO', key: 'organismo', width: 35 },
          { header: 'N° de CASO', key: 'numeroCaso', width: 12 },
          { header: 'FECHA DE NACIMIENTO DEL CASO', key: 'fechaNacimiento', width: 25 },
          { header: 'PERIODO DE GESTION', key: 'periodoGestion', width: 20 },
          { header: 'TIPO DE IDENTIFICACIÓN', key: 'tipoIdentificacion', width: 20 },
          { header: 'IDENTIFICACIÓN', key: 'identificacion', width: 18 },
          { header: 'NOMBRE DEL SUJETO', key: 'nombreSujeto', width: 35 },
          { header: 'CANTIDAD DE OBJETOS INICIO', key: 'cantidadObjetosInicio', width: 25 },
          { header: 'CANTIDAD DE OBJETOS FINAL', key: 'cantidadObjetosFinal', width: 25 },
          { header: 'OBJETOS', key: 'objetos', width: 80 },
          { header: 'MONTO INICIO', key: 'montoInicio', width: 18 },
          { header: 'MONTO FINAL', key: 'montoFinal', width: 18 },
          { header: 'DIFERENCIA DE MONTO', key: 'diferenciaMonto', width: 18 },
          { header: 'ÚLTIMO ESTADO', key: 'ultimoEstado', width: 20 },
          { header: 'ÚLTIMO EVENTO', key: 'ultimoEvento', width: 30 },
          { header: 'FECHA ÚLTIMO EVENTO', key: 'fechaUltimoEvento', width: 16 },
          { header: 'HORA ÚLTIMO EVENTO', key: 'horaUltimoEvento', width: 14 },
          { header: 'ESTADO CIERRE', key: 'estadoCierre', width: 20 },
          { header: 'NRO CASO ANTERIOR', key: 'idCasoAnterior', width: 18 },
          { header: 'ESTADO CASO ANTERIOR', key: 'estadoCasoAnterior', width: 25 },
          { header: 'CONTACTOS', key: 'contactos', width: 60 },
          ...(cfg.usaMotivo ? [{ header: 'MOTIVO DE LA CAMPAÑA', key: 'motivo', width: 35 }] : []),
          ...(modo === "prejudicial" ? [{ header: 'PUNTAJE', key: 'puntaje', width: 12 }] : [])
        ];
      }

      // Estilo del encabezado
      worksheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
      worksheet.getRow(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF1976D2' }
      };
      worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

      // Agregar datos
      dataParaReporte.forEach((item) => {
        const montoInicio = item.monto || 0;
        const montoFinal = item.montoFinal || 0;
        const diferenciaMonto = montoInicio - montoFinal;
        const fechaUltimoEvento = item.fechaUltimoEvento ? dayjs(item.fechaUltimoEvento) : null;
        const fechaUltimoEventoValida = fechaUltimoEvento && fechaUltimoEvento.isValid();

        const rowData = {
          usuario: item.usuario || '',
          organismo: item.organismo || '',
          numeroCaso: item.idCaso || '',
          fechaNacimiento: item.fecha ? dayjs(item.fecha).format('DD/MM/YYYY') : '',
          periodoGestion: item.periodoGestion || item.PeriodoGestion || '',
          tipoIdentificacion: item.tipoIdentificacion || '',
          identificacion: item.identificacion || '',
          nombreSujeto: item.nombreSujeto || '',
          cantidadObjetosInicio: item.cantidadObjetos || 0,
          cantidadObjetosFinal: item.objetosFinal || 0,
          montoInicio: montoInicio,
          montoFinal: montoFinal,
          diferenciaMonto: diferenciaMonto,
          ultimoEstado: item.estado || '',
          ultimoEvento: item.ultimoEvento || '',
          fechaUltimoEvento: fechaUltimoEventoValida ? fechaUltimoEvento.format('DD/MM/YYYY') : '',
          horaUltimoEvento: fechaUltimoEventoValida ? fechaUltimoEvento.format('HH:mm') : '',
          estadoCierre: item.tipoCierreDescripcion || '',
          motivo: item.motivo || '',
          puntaje: puntajesExcel[item.idCaso]?.puntaje ?? ''
        };

        // Formatear objetos (para ambos tipos de reporte)
        if (item.objetos && item.objetos.trim()) {
          const objetosFormatted = item.objetos
            .split(';')
            .map(obj => obj.trim().replace(/,(?=\S)/g, ', '))
            .filter(obj => obj)
            .join('; ');
          rowData.objetos = objetosFormatted;
        } else {
          rowData.objetos = '';
        }

        // Si es detallado, agregar columnas adicionales
        if (exportarExcelDialog.tipoReporte === "Detallado") {
          // Agregar columnas de caso anterior
          rowData.idCasoAnterior = item.idCasoAnterior || '';
          rowData.estadoCasoAnterior = item.estadoCasoAnterior || '';

          // Formatear contactos
          if (item.sujetoContactos && item.sujetoContactos.length > 0) {
            // Formatear contactos como "TipoContacto: valor (Prioridad)"
            const contactosFormatted = item.sujetoContactos.map(c => {
              let contactoStr = `${c.tipoContacto || 'Sin tipo'}: ${c.contacto || 'Sin contacto'}`;
              if (c.prioridadNombre) {
                contactoStr += ` (${c.prioridadNombre})`;
              }
              return contactoStr;
            }).join(', ');
            rowData.contactos = contactosFormatted;
          } else {
            rowData.contactos = '';
          }
        }

        worksheet.addRow(rowData);
      });

      // Ajustar formato de números y texto enriquecido. Las columnas se buscan por su key y no por su posición: agregar o mover una
      // columna (como pasó con PERIODO DE GESTION) corría los formatos a la columna de al lado.
      const columnaDe = (key) => worksheet.getColumn(key).number;
      const colObjetosInicio = columnaDe('cantidadObjetosInicio');
      const colObjetosFinal = columnaDe('cantidadObjetosFinal');
      const colMontoInicio = columnaDe('montoInicio');
      const colMontoFinal = columnaDe('montoFinal');
      const colDiferenciaMonto = columnaDe('diferenciaMonto');
      const colObjetos = columnaDe('objetos');

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {
          row.getCell(colObjetosInicio).numFmt = '#,##0';
          row.getCell(colObjetosFinal).numFmt = '#,##0';
          row.getCell(colMontoInicio).numFmt = '$#,##0.00';
          row.getCell(colMontoFinal).numFmt = '$#,##0.00';
          row.getCell(colDiferenciaMonto).numFmt = '$#,##0.00';

          // Aplicar formato especial a la columna de objetos (ambos reportes)
          const objetosCell = row.getCell(colObjetos);
          const objetosText = objetosCell.value;

          if (objetosText && typeof objetosText === 'string') {
            // Crear rich text con títulos "Cuenta n°" en negrita y azul
            const richText = [];
            const parts = objetosText.split(', ');

            parts.forEach((part, index) => {
              // Buscar patrón de título seguido de "Cuenta n°"
              const match = part.match(/^([^0-9]+)(Cuenta n°.+)$/);

              if (match) {
                // Título en negrita y azul
                richText.push({
                  font: { bold: true, color: { argb: 'FF1976D2' } },
                  text: match[1]
                });
                // Resto del texto normal
                richText.push({
                  font: { bold: false, color: { argb: 'FF000000' } },
                  text: match[2]
                });
              } else {
                // Texto normal
                richText.push({
                  font: { bold: false, color: { argb: 'FF000000' } },
                  text: part
                });
              }

              // Agregar separador excepto en el último
              if (index < parts.length - 1) {
                richText.push({
                  font: { bold: false, color: { argb: 'FF000000' } },
                  text: ', '
                });
              }
            });

            objetosCell.value = { richText };
          }
        }
      });

      // Generar archivo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const tipoSufijo = exportarExcelDialog.tipoReporte === "Resumido" ? "Resumido" : "Detallado";
      a.download = `Reporte_Casos_${tipoSufijo}_${dayjs().format('YYYYMMDD_HHmmss')}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);

      if (puntajesDisponibles) {
        setSnackbar({ open: true, msg: "Reporte exportado correctamente", severity: "success" });
      } else {
        setSnackbar({ open: true, msg: "Reporte exportado, pero sin los puntajes: no se pudieron consultar", severity: "warning" });
      }
      handleCloseExportarExcel();
    } catch (ex) {
      console.error("Error exportando a Excel:", ex);
      setSnackbar({ open: true, msg: "Error al exportar el reporte", severity: "error" });
    } finally {
      setExportarExcelDialog(prev => ({ ...prev, exportando: false }));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };


  const handleOpenAgenda = (idCaso, nombreSujeto) => {
    const caso = rawData.find(c => c.idCaso === idCaso);
    if (!caso) return;

    setAgendaDialog({
      open: true,
      idCaso: idCaso,
      idSujeto: caso.idSujeto || 0,
      nombreSujeto: nombreSujeto || caso.nombreSujeto || "",
      fecha: dayjs(),
      observaciones: ""
    });
  };

  const handleCloseAgenda = () => {
    setAgendaDialog({
      open: false,
      idCaso: null,
      idSujeto: null,
      nombreSujeto: "",
      fecha: dayjs(),
      observaciones: ""
    });
  };

  const handleGuardarAgenda = async () => {
    if (!agendaDialog.fecha || !agendaDialog.observaciones.trim()) {
      setSnackbar({ open: true, msg: "Debe completar fecha y observaciones", severity: "warning" });
      return;
    }

    setGuardandoAgenda(true);
    try {
      const payload = {
        idUsuario: parseInt(localStorage.getItem("iduserlogueado")) || 0,
        idCaso: agendaDialog.idCaso,
        idSujeto: agendaDialog.idSujeto,
        nombreSujeto: agendaDialog.nombreSujeto,
        fecha: agendaDialog.fecha.format('YYYY-MM-DD'),
        observaciones: agendaDialog.observaciones,
        visto: 0,
        tipo: cfg.tipoAgenda
      };

      const response = await postData("/CasoAgendaRegistrar", payload);

      if (response?.isSuccess) {
        setSnackbar({ open: true, msg: "Agenda registrada correctamente", severity: "success" });
        handleCloseAgenda();
        // Recargar notificaciones
        await cargarAgendasHoy();
      } else {
        setSnackbar({ open: true, msg: response?.error || "Error al registrar agenda", severity: "error" });
      }
    } catch (ex) {
      console.error("Error registrando agenda:", ex);
      setSnackbar({ open: true, msg: "Error al registrar agenda", severity: "error" });
    } finally {
      setGuardandoAgenda(false);
    }
  };

  const cargarAgendasHoy = async () => {
    try {
      const idUsuario = parseInt(localStorage.getItem("iduserlogueado")) || 0;
      const hoy = dayjs().format('YYYY-MM-DD');

      const response = await postData("/CasoAgendaListar", {
        idUsuario: idUsuario,
        fechaDesde: hoy,
        fechaHasta: hoy,
        Tipo: "" // sin filtro: el usuario ve todas sus agendas (cada una indica el tipo de caso)
      });

      const list = response?.value || [];

      // Contar no vistas
      const noVistas = list.filter(a => a.visto === 0 || a.visto === false).length;
      setAgendasNoVistas(noVistas);
    } catch (ex) {
      console.error("Error cargando agendas para notificaciones:", ex);
    }
  };

  const cargarAgendasConFiltros = async () => {
    setLoadingAgendas(true);
    try {
      const idUsuario = parseInt(localStorage.getItem("iduserlogueado")) || 0;

      const response = await postData("/CasoAgendaListar", {
        idUsuario: idUsuario,
        fechaDesde: agendaFilters.fechaDesde.format('YYYY-MM-DD'),
        fechaHasta: agendaFilters.fechaHasta.format('YYYY-MM-DD'),
        Tipo: "" // sin filtro: el usuario ve todas sus agendas (cada una indica el tipo de caso)
      });

      const list = response?.value || [];
      setAgendasHoy(list);
      aplicarFiltroNombre(list, agendaFilters.nombreSujeto);
    } catch (ex) {
      console.error("Error cargando agendas:", ex);
      setSnackbar({ open: true, msg: "Error al cargar las agendas", severity: "error" });
    } finally {
      setLoadingAgendas(false);
    }
  };

  const aplicarFiltroNombre = (agendas, nombreFiltro) => {
    if (!nombreFiltro || nombreFiltro.trim() === "") {
      setAgendasFiltradas(agendas);
    } else {
      const filtradas = agendas.filter(a =>
        a.nombreSujeto?.toLowerCase().includes(nombreFiltro.toLowerCase())
      );
      setAgendasFiltradas(filtradas);
    }
  };

  const handleMarcarVisto = async (idAgenda) => {
    try {
      const response = await postData(`/CasoAgendaMarcarVisto/${idAgenda}`, {});

      if (response?.isSuccess) {
        // Recargar agendas
        await cargarAgendasConFiltros();
        await cargarAgendasHoy();
      }
    } catch (ex) {
      console.error("Error marcando agenda como vista:", ex);
    }
  };

  const handleOpenNotificaciones = async () => {
    const newFilters = {
      fechaDesde: dayjs(),
      fechaHasta: dayjs(),
      nombreSujeto: ""
    };
    setAgendaFilters(newFilters);
    setNotificacionesDialog(true);

    // Cargar agendas con los filtros iniciales
    setLoadingAgendas(true);
    try {
      const idUsuario = parseInt(localStorage.getItem("iduserlogueado")) || 0;

      const response = await postData("/CasoAgendaListar", {
        idUsuario: idUsuario,
        fechaDesde: newFilters.fechaDesde.format('YYYY-MM-DD'),
        fechaHasta: newFilters.fechaHasta.format('YYYY-MM-DD'),
        Tipo: "" // sin filtro: el usuario ve todas sus agendas (cada una indica el tipo de caso)
      });

      const list = response?.value || [];
      setAgendasHoy(list);
      setAgendasFiltradas(list);
    } catch (ex) {
      console.error("Error cargando agendas:", ex);
      setSnackbar({ open: true, msg: "Error al cargar las agendas", severity: "error" });
    } finally {
      setLoadingAgendas(false);
    }
  };

  const handleCloseNotificaciones = () => {
    setNotificacionesDialog(false);
    setAgendasHoy([]);
    setAgendasFiltradas([]);
  };

  const handleAgendaFilterChange = (e) => {
    const { name, value } = e.target;
    const newFilters = { ...agendaFilters, [name]: value };
    setAgendaFilters(newFilters);

    // Aplicar filtro de nombre en tiempo real sobre los datos ya cargados
    if (name === "nombreSujeto") {
      aplicarFiltroNombre(agendasHoy, value);
    }
  };

  const handleBuscarAgendas = async () => {
    await cargarAgendasConFiltros();
  };

  const handleAgregarEvento = async (idCaso) => {
    const caso = rawData.find(c => c.idCaso === idCaso);
    if (!caso) return;

    console.log("caso", caso);
    const idCasoEstado = caso.idCasoEstado || 0;

    // Cargar tipos de evento filtrados por el estado del caso
    try {
      const data = await cfg.fetchTiposEvento(idCasoEstado);
      setTiposEvento(data.map(t => ({
        id: t.idCasoEventoTipo, label: t.descripcion, activo: t.activo,
        // Solo Pre-Judicial: si el caso vuelve a proponerse con este evento y en cuántos días (undefined = no se sabe).
        vuelve: t.vuelveAProponerse, dias: t.diasEsperaEfectivos
      })));
    } catch (ex) {
      console.error("Error cargando tipos de evento:", ex);
      setSnackbar({ open: true, msg: "Error al cargar los tipos de evento", severity: "error" });
    }

    setEventoDialog({
      open: true,
      idCaso: idCaso,
      idCasoEstado: idCasoEstado,
      idSujeto: caso.idSujeto || null,
      nombreSujeto: caso.nombreSujeto || "",
      observaciones: "",
      tipoEvento: null,
      guardando: false,
      agendarLlamada: false,
      fechaAgenda: dayjs(),
      observacionesAgenda: ""
    });
  };

  const handleCloseEvento = () => {
    setEventoDialog({
      open: false,
      idCaso: null,
      idCasoEstado: null,
      idSujeto: null,
      nombreSujeto: "",
      observaciones: "",
      tipoEvento: null,
      guardando: false,
      agendarLlamada: false,
      fechaAgenda: dayjs(),
      observacionesAgenda: ""
    });
    setTiposEvento([]);
  };

  const handleGuardarEvento = async () => {
    if (!eventoDialog.tipoEvento) {
      setSnackbar({ open: true, msg: "Debe seleccionar un tipo de evento", severity: "warning" });
      return;
    }
    if (!eventoDialog.observaciones.trim()) {
      setSnackbar({ open: true, msg: "Las observaciones son requeridas", severity: "warning" });
      return;
    }

    // Validar campos de agenda si el checkbox está marcado
    if (eventoDialog.agendarLlamada) {
      if (!eventoDialog.fechaAgenda || !eventoDialog.observacionesAgenda.trim()) {
        setSnackbar({ open: true, msg: "Debe completar fecha y observaciones de la agenda", severity: "warning" });
        return;
      }
    }

    setEventoDialog(prev => ({ ...prev, guardando: true }));

    try {
      // 1. Registrar el evento
      const payloadEvento = {
        idUsuario: parseInt(localStorage.getItem("iduserlogueado")) || 0,
        idCasoEventoTipo: eventoDialog.tipoEvento.id,
        observaciones: eventoDialog.observaciones,
        idCaso: eventoDialog.idCaso
      };

      const responseEvento = await postData(cfg.api.registrarEvento, payloadEvento);

      if (!responseEvento?.isSuccess) {
        setSnackbar({ open: true, msg: responseEvento?.error || "Error al registrar evento", severity: "error" });
        setEventoDialog(prev => ({ ...prev, guardando: false }));
        return;
      }

      // 2. Si tiene agenda marcada, registrar la agenda
      if (eventoDialog.agendarLlamada) {
        const payloadAgenda = {
          idUsuario: parseInt(localStorage.getItem("iduserlogueado")) || 0,
          idCaso: eventoDialog.idCaso,
          idSujeto: eventoDialog.idSujeto,
          nombreSujeto: eventoDialog.nombreSujeto,
          fecha: eventoDialog.fechaAgenda.format('YYYY-MM-DD'),
          observaciones: eventoDialog.observacionesAgenda,
          visto: 0,
          tipo: cfg.tipoAgenda
        };

        const responseAgenda = await postData("/CasoAgendaRegistrar", payloadAgenda);

        if (!responseAgenda?.isSuccess) {
          setSnackbar({ open: true, msg: responseAgenda?.error || "Evento guardado, pero error al registrar agenda", severity: "warning" });
          setEventoDialog(prev => ({ ...prev, guardando: false }));
          return;
        }

        // Recargar notificaciones
        await cargarAgendasHoy();
        setSnackbar({ open: true, msg: "Evento y agenda registrados correctamente", severity: "success" });
      } else {
        setSnackbar({ open: true, msg: "Evento registrado correctamente", severity: "success" });
      }

      handleCloseEvento();
      // El resumen de la barra superior (gestiones de hoy) se actualiza sin esperar a los 5 minutos.
      recargarResumenGestion();

      // Actualizar solo el caso específico en rawData
      setRawData(prevData => prevData.map(item => {
        if (item.idCaso === eventoDialog.idCaso) {
          // Si el backend devuelve el estado actualizado en responseEvento.data o responseEvento.value
          const nuevoEstado = responseEvento.data?.estado || responseEvento.value?.estado;
          const nuevoIdCasoEstado = responseEvento.data?.idCasoEstado || responseEvento.value?.idCasoEstado;

          return {
            ...item,
            ultimoEvento: eventoDialog.tipoEvento.label,
            fechaUltimoEvento: new Date().toISOString(),
            // Solo actualizar el estado si vino en la respuesta
            ...(nuevoEstado && { estado: nuevoEstado }),
            ...(nuevoIdCasoEstado && { idCasoEstado: nuevoIdCasoEstado })
          };
        }
        return item;
      }));

      // Disparador: si el evento es del caso asignado, el backend ya cerró la propuesta. Se pide el estado de nuevo: a quien tiene
      // asignación automática hoy le llega el próximo caso (y la grilla pasa a mostrarlo); un voluntario vuelve a poder pedir uno.
      if (propuestaActiva && propuesta?.propuesta?.idCaso === eventoDialog.idCaso)
        await ejecutarPropuesta("/CasoPropuestaActual");
    } catch (ex) {
      console.error("Error registrando evento:", ex);
      setSnackbar({ open: true, msg: "Error al registrar evento", severity: "error" });
    } finally {
      setEventoDialog(prev => ({ ...prev, guardando: false }));
    }
  };

  const handleSeguimiento = async (idCaso) => {
    setSeguimientoDialog({ open: true, idCaso, eventos: [], loading: true });

    try {
      const res = await getData(cfg.api.eventosPorCaso(idCaso));
      const eventos = res?.value || [];
      setSeguimientoDialog(prev => ({ ...prev, eventos, loading: false }));
    } catch (error) {
      console.error('Error cargando eventos del caso:', error);
      setSnackbar({ open: true, msg: 'Error al cargar el seguimiento', severity: 'error' });
      setSeguimientoDialog(prev => ({ ...prev, loading: false }));
    }
  };

  const handleCloseSeguimiento = () => {
    setSeguimientoDialog({ open: false, idCaso: null, eventos: [], loading: false });
    setObservacionesExpandidas({});
  };

  const toggleObservaciones = (idEvento) => {
    setObservacionesExpandidas(prev => ({
      ...prev,
      [idEvento]: !prev[idEvento]
    }));
  };

  const handleOpenMailDialog = () => {
    setMailDialog({
      open: true,
      idCaso: seguimientoDialog.idCaso,
      para: "",
      cc: "",
      asunto: `Seguimiento del Caso #${seguimientoDialog.idCaso}`,
      cuerpo: "",
      enviando: false
    });
  };

  const handleCloseMailDialog = () => {
    setMailDialog({
      open: false,
      idCaso: null,
      para: "",
      cc: "",
      asunto: "",
      cuerpo: "",
      enviando: false
    });
  };

  const handleEnviarMail = async () => {
    if (!mailDialog.para || !mailDialog.asunto || !mailDialog.cuerpo) {
      setSnackbar({ open: true, msg: "Debe completar Para, Asunto y Cuerpo del correo", severity: "warning" });
      return;
    }

    setMailDialog(prev => ({ ...prev, enviando: true }));

    try {
      const payload = {
        idCaso: mailDialog.idCaso,
        para: mailDialog.para,
        cc: mailDialog.cc || "",
        asunto: mailDialog.asunto,
        cuerpo: mailDialog.cuerpo
      };

      const response = await postData(cfg.api.mailSeguimiento, payload);

      if (response?.isSuccess) {
        setSnackbar({ open: true, msg: "Correo enviado correctamente", severity: "success" });
        handleCloseMailDialog();
      } else {
        setSnackbar({ open: true, msg: response?.error || "Error al enviar el correo", severity: "error" });
      }
    } catch (ex) {
      console.error("Error enviando correo:", ex);
      setSnackbar({ open: true, msg: "Error al enviar el correo", severity: "error" });
    } finally {
      setMailDialog(prev => ({ ...prev, enviando: false }));
    }
  };

  const handleImprimirSeguimiento = () => {
    const printWindow = window.open('', '_blank');

    const htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Seguimiento del Caso #${seguimientoDialog.idCaso}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          h1 { color: #333; border-bottom: 2px solid #1976d2; padding-bottom: 10px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th { background-color: #1976d2; color: white; padding: 12px; text-align: left; font-weight: bold; }
          td { padding: 10px; border-bottom: 1px solid #ddd; }
          tr:hover { background-color: #f5f5f5; }
          .observaciones { white-space: pre-wrap; }
        </style>
      </head>
      <body>
        <h1>Seguimiento del Caso #${seguimientoDialog.idCaso}</h1>
        <p><strong>Fecha de impresión:</strong> ${dayjs().format('DD/MM/YYYY HH:mm:ss')}</p>
        <table>
          <thead>
            <tr>
              <th>Fecha/Hora</th>
              <th>Usuario</th>
              <th>Tipo Evento</th>
              <th>Observaciones</th>
            </tr>
          </thead>
          <tbody>
            ${seguimientoDialog.eventos.map(evento => `
              <tr>
                <td>${dayjs(evento.fecha).format('DD/MM/YYYY HH:mm:ss')}</td>
                <td>${evento.usuarioNombre}</td>
                <td>${evento.eventoTipo}</td>
                <td class="observaciones">${evento.observaciones}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </body>
      </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const handleTraspasar = async (idCaso) => {
    // Buscar el caso actual para obtener el nombre del sujeto
    const caso = rawData.find(c => c.idCaso === idCaso);
    if (!caso) return;

    setVincularDialog({
      open: true,
      idCaso: idCaso,
      nombreSujetoCaso: caso.nombreSujeto || "",
      identificacionCaso: caso.identificacion || "",
      sujetoRealVinculado: caso.sujetoRealVinculado || 0
    });
    setVincularFilters({ nombre: caso.nombreSujeto || "", identificacion: "", dni: "" });
    setSelectedSujeto(null);

    // Realizar búsqueda automática con el nombre del sujeto del caso
    await buscarSujetosParaVincular({ nombre: caso.nombreSujeto || "", identificacion: "", dni: "" });
  };

  const buscarSujetosParaVincular = async (filters) => {
    setLoadingSujetos(true);
    try {
      // Validaciones
      const errors = { cuit: "", dni: "", both: "" };

      if (filters.identificacion && filters.dni) {
        errors.both = "Solo puede filtrar por CUIT o DNI, no ambos";
        setVincularValidationErrors(errors);
        setLoadingSujetos(false);
        return;
      }

      if (filters.identificacion && filters.identificacion.length !== 11) {
        errors.cuit = "El CUIT debe tener exactamente 11 dígitos";
        setVincularValidationErrors(errors);
        setLoadingSujetos(false);
        return;
      }

      if (filters.dni && filters.dni.length !== 8) {
        errors.dni = "El DNI debe tener exactamente 8 dígitos";
        setVincularValidationErrors(errors);
        setLoadingSujetos(false);
        return;
      }

      setVincularValidationErrors({ cuit: "", dni: "", both: "" });

      const req = {
        nombre: filters.nombre || "",
        identificacion: filters.identificacion || "",
        dni: filters.dni || ""
      };

      const response = await postData("/SujetoCasosbyParams", req);
      const list = response?.value || [];

      const options = list
        .filter(s => s.idSujetoTipoIdentificacion === 1 || s.idSujetoTipoIdentificacion === 2 || s.idSujetoTipoIdentificacion === 3)
        .map(s => ({
          id: s.idSujeto,
          nombre: s.nombre,
          domicilio: s.domicilio,
          identificacion: s.identificacion,
          tipoIdentificacion: s.tipoIdentificacion,
          idSujetoTipoIdentificacion: s.idSujetoTipoIdentificacion
        }));

      setSujetosOptions(options);
    } catch (ex) {
      console.error("Error buscando sujetos:", ex);
      setSnackbar({ open: true, msg: "Error al buscar sujetos", severity: "error" });
    } finally {
      setLoadingSujetos(false);
    }
  };

  const handleVincularFilterChange = (e) => {
    const { name, value } = e.target;

    // Solo permitir números
    if ((name === "identificacion" || name === "dni") && value && !/^\d*$/.test(value)) {
      return;
    }

    setVincularFilters({ ...vincularFilters, [name]: value });

    // Validaciones en tiempo real
    const newErrors = { cuit: "", dni: "", both: "" };

    if (name === "identificacion") {
      if (value && value.length !== 11 && value.length > 0) {
        newErrors.cuit = "El CUIT debe tener exactamente 11 dígitos";
      }
      if (value && vincularFilters.dni) {
        newErrors.both = "Solo puede filtrar por CUIT o DNI, no ambos";
      }
    }

    if (name === "dni") {
      if (value && value.length !== 8 && value.length > 0) {
        newErrors.dni = "El DNI debe tener exactamente 8 dígitos";
      }
      if (value && vincularFilters.identificacion) {
        newErrors.both = "Solo puede filtrar por CUIT o DNI, no ambos";
      }
    }

    // Validar si ambos están llenos
    const updatedFilters = { ...vincularFilters, [name]: value };
    if (updatedFilters.identificacion && updatedFilters.dni) {
      newErrors.both = "Solo puede filtrar por CUIT o DNI, no ambos";
    }

    setVincularValidationErrors(newErrors);
  };

  const handleBuscarSujetos = async () => {
    // Validar que al menos un filtro tenga valor
    if (!vincularFilters.nombre && !vincularFilters.identificacion && !vincularFilters.dni) {
      setSnackbar({ open: true, msg: "Debe ingresar al menos un filtro para realizar la búsqueda", severity: "warning" });
      return;
    }

    await buscarSujetosParaVincular(vincularFilters);
  };

  const handleVincularKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleBuscarSujetos();
    }
  };

  const handleCloseVincular = () => {
    setVincularDialog({ open: false, idCaso: null, nombreSujetoCaso: "", identificacionCaso: "", sujetoRealVinculado: 0 });
    setVincularFilters({ nombre: "", identificacion: "", dni: "" });
    setVincularValidationErrors({ cuit: "", dni: "", both: "" });
    setSujetosOptions([]);
    setSelectedSujeto(null);
  };

  const handleAceptarVincular = async () => {
    if (!selectedSujeto) {
      setSnackbar({ open: true, msg: "Debe seleccionar un sujeto", severity: "warning" });
      return;
    }

    setVinculando(true);

    try {
      const payload = {
        idCaso: vincularDialog.idCaso,
        idSujetoReal: selectedSujeto.id,
        nombreSujeto: selectedSujeto.nombre,
        identificacion: selectedSujeto.identificacion,
        tipoIdentificacion: selectedSujeto.tipoIdentificacion,
        IdSujetoTipoIdentificacion: selectedSujeto.idSujetoTipoIdentificacion || 0,
        idUsuario: parseInt(localStorage.getItem("iduserlogueado")) || 0
      };
      console.log("Vinculando sujeto:", payload);
      const response = await postData(cfg.api.vincularSujetoReal, payload);

      if (response?.isSuccess) {
        setSnackbar({ open: true, msg: "Sujeto vinculado correctamente", severity: "success" });

        // Guardar posición del scroll antes de actualizar
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        // Actualizar rawData directamente sin recargar
        setRawData(prevData => prevData.map(item => {
          if (item.idCaso === vincularDialog.idCaso) {
            // Si el backend devuelve los datos actualizados en response.data o response.value
            const nuevoTipoIdentificacion = response.data?.tipoIdentificacion || response.value?.tipoIdentificacion || selectedSujeto.tipoIdentificacion;
            const nuevaIdentificacion = response.data?.identificacion || response.value?.identificacion || selectedSujeto.identificacion;
            const nuevoNombreSujeto = response.data?.nombreSujeto || response.value?.nombreSujeto || selectedSujeto.nombre;
            const nuevoIdSujeto = response.data?.idSujeto || response.value?.idSujeto || selectedSujeto.id;

            return {
              ...item,
              sujetoRealVinculado: 1,
              tipoIdentificacion: nuevoTipoIdentificacion,
              identificacion: nuevaIdentificacion,
              nombreSujeto: nuevoNombreSujeto,
              idSujeto: nuevoIdSujeto,
              idSujetoReal: selectedSujeto.id,
              // Actualizar también campos relacionados si es necesario
              tipoIdentificacionAnt: item.tipoIdentificacion, // Guardar el anterior
              identificacionAnt: item.identificacion, // Guardar el anterior
              // El sujeto provisorio que traía el caso: la información del sujeto vinculado lo muestra aunque la base no tenga su detalle.
              sujetoProvisorioAnt: { idSujeto: item.idSujeto, nombre: item.nombreSujeto, tipoIdentificacion: item.tipoIdentificacion, identificacion: item.identificacion }
            };
          }
          return item;
        }));

        // Restaurar la posición del scroll después de un breve delay
        setTimeout(() => {
          window.scrollTo(0, scrollPosition);
        }, 0);

        handleCloseVincular();
      } else {
        setSnackbar({ open: true, msg: response?.error || "Error al vincular sujeto", severity: "error" });
      }
    } catch (ex) {
      console.error("Error vinculando sujeto:", ex);
      setSnackbar({ open: true, msg: "Error al vincular sujeto", severity: "error" });
    } finally {
      setVinculando(false);
    }
  };

  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const handleEntriesPerPageChange = (newValue) => {
    setEntriesPerPage(newValue);
    setCookie(`${cfg.cookiePrefix}EntriesPerPage`, newValue.toString(), 43200); // 30 días
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {cfg.titulo}
                </MDTypography>
                <MDBox display="flex" alignItems="center">
                  <ManualAyuda seccion={cfg.ayuda} />
                  <MuiIconButton
                    onClick={handleOpenNotificaciones}
                    sx={{ color: 'white' }}
                  >
                    <Badge
                      badgeContent={agendasNoVistas}
                      color="error"
                      sx={{
                        '& .MuiBadge-badge': {
                          fontWeight: agendasNoVistas > 0 ? 'bold' : 'normal'
                        }
                      }}
                    >
                      <Notifications sx={{ fontSize: 28 }} />
                    </Badge>
                  </MuiIconButton>
                </MDBox>
              </MDBox>

              <MDBox pt={3} py={3} px={2}>
                {usaDisparador && (
                  <PanelPropuesta
                    propuesta={propuesta}
                    error={propuestaError}
                    procesando={procesandoPropuesta}
                    onPausar={() => ejecutarPropuesta("/CasoPropuestaPausar")}
                    onRetomar={() => ejecutarPropuesta("/CasoPropuestaRetomar")}
                    onPedir={() => ejecutarPropuesta("/CasoPropuestaPedir")}
                    onReintentar={() => ejecutarPropuesta("/CasoPropuestaActual")}
                  />
                )}

                {/* Con un caso asignado (propuesta ACTIVA) los filtros quedan bloqueados: se atiende ese caso y nada más. Se usa un
                    <div> común porque `inert` también saca los campos del foco del teclado. */}
                <div
                  style={propuestaActiva ? { pointerEvents: "none", opacity: 0.45 } : undefined}
                  {...(propuestaActiva ? { inert: "" } : {})}
                >
                {/* Primera fila de filtros */}
                <MDBox mb={2} display="flex" gap={2} flexWrap="wrap" alignItems="center">
                  <MDInput
                    name="nombreSujeto"
                    label="Nombre de Sujeto"
                    value={filters.nombreSujeto}
                    onChange={handleFilterChange}
                    onKeyDown={handleKeyDown}
                    sx={{ width: 200, height: 50 }}
                  />
                  <MDInput
                    name="identificacion"
                    label="Identificación"
                    value={filters.identificacion}
                    onChange={handleFilterChange}
                    onKeyDown={handleKeyDown}
                    sx={{ width: 200, height: 50 }}
                  />
                  <MDInput
                    name="objetos"
                    label="Objetos"
                    value={filters.objetos}
                    onChange={handleFilterChange}
                    onKeyDown={handleKeyDown}
                    sx={{ width: 200, height: 50 }}
                  />
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    limitTags={1}
                    options={periodOptions}
                    getOptionLabel={(option) => option.label || ""}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    value={periodOptions.filter(p => (filters.periodoGestion || []).includes(p.value))}
                    onChange={handlePeriodoGestionChange}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox size="small" checked={selected} sx={{ mr: 1 }} />
                        {option.label}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} label="Periodo Gestion" />
                    )}
                    sx={{ width: 300 }}
                  />
                  {cfg.usaMotivo && (
                    <Autocomplete
                      options={motivos}
                      getOptionLabel={(option) => option.descripcion || ""}
                      isOptionEqualToValue={(option, value) => option.idMotivoCualitativo === value.idMotivoCualitativo}
                      value={motivos.find((m) => m.idMotivoCualitativo === filters.idMotivoCualitativo) || null}
                      onChange={handleMotivoChange}
                      renderInput={(params) => <TextField {...params} label="Motivo de la campaña" />}
                      sx={{ width: 320 }}
                    />
                  )}
                  <Autocomplete
                    options={organismos}
                    getOptionLabel={(option) => option.label || ""}
                    getOptionDisabled={(option) => !option.activo}
                    value={organismos.find(o => o.id === filters.idOrganismo) || null}
                    onChange={handleOrganismoChange}
                    renderInput={(params) => <TextField {...params} label="Organismo" />}
                    sx={{ width: 400 }}
                  />
                  <Autocomplete
                    options={usuarios}
                    getOptionLabel={(option) => option.label || ""}
                    getOptionDisabled={(option) => !option.activo}
                    value={usuarios.find(u => u.id === filters.idUsuario) || null}
                    onChange={handleUsuarioChange}
                    renderInput={(params) => <TextField {...params} label="Gestor" />}
                    sx={{ width: 200 }}
                  />
                  <Autocomplete
                    options={["Todos", "Si", "No"]}
                    value={filters.poseeContactos}
                    onChange={handlePoseeContactosChange}
                    renderInput={(params) => <TextField {...params} label="Posee Contactos" />}
                    sx={{ width: 200 }}
                  />
                  <Autocomplete
                    options={["Todos", "Si", "No"]}
                    value={filters.poseeCuit}
                    onChange={handlePoseeCuitChange}
                    renderInput={(params) => <TextField {...params} label="Posee Cuit" />}
                    sx={{ width: 200 }}
                  />
                  <Autocomplete
                    options={cfg.tiposCierre.map(tc => tc.label)}
                    value={cfg.tiposCierre.find(tc => tc.value === filters.TipoCierre)?.label || "Todos"}
                    onChange={handleIdTipoCierreChange}
                    renderInput={(params) => <TextField {...params} label="Estado Cierre" />}
                    sx={{ width: 250 }}
                  />
                </MDBox>
                {/* Segunda fila de filtros */}
                <MDBox mb={2} display="flex" gap={2} flexWrap="wrap" alignItems="center">
                  <Autocomplete
                    options={estados}
                    getOptionLabel={(option) => option.label || ""}
                    value={estados.find(e => e.id === filters.idCasoEstado) || null}
                    onChange={handleEstadoChange}
                    renderInput={(params) => <TextField {...params} label="Estado" />}
                    sx={{ width: 200 }}
                  />
                  <MDInput
                    name="numeroCaso"
                    label="Número de Caso"
                    type="number"
                    value={filters.numeroCaso}
                    onChange={handleFilterChange}
                    onKeyDown={handleKeyDown}
                    sx={{ width: 200, height: 50 }}
                  />
                  <MDInput
                    name="cantidadObjetosDesde"
                    label="Cant. Objetos Desde"
                    type="number"
                    value={filters.cantidadObjetosDesde}
                    onChange={handleFilterChange}
                    onKeyDown={handleKeyDown}
                    sx={{ width: 200, height: 50 }}
                  />
                  <MDInput
                    name="cantidadObjetosHasta"
                    label="Cant. Objetos Hasta"
                    type="number"
                    value={filters.cantidadObjetosHasta}
                    onChange={handleFilterChange}
                    onKeyDown={handleKeyDown}
                    sx={{ width: 200, height: 50 }}
                  />
                  <MDInput
                    name="montoDesde"
                    label="Monto Desde ($)"
                    type="number"
                    value={filters.montoDesde}
                    onChange={handleFilterChange}
                    onKeyDown={handleKeyDown}
                    sx={{ width: 200, height: 50 }}
                  />
                  <MDInput
                    name="montoHasta"
                    label="Monto Hasta ($)"
                    type="number"
                    value={filters.montoHasta}
                    onChange={handleFilterChange}
                    onKeyDown={handleKeyDown}
                    sx={{ width: 200, height: 50 }}
                  />
                </MDBox>
                {/* Tercera fila de filtros */}
                <MDBox mb={2} display="flex" gap={2} flexWrap="wrap" alignItems="center">
                  <MDButton variant="contained" color="info" onClick={handleSearch}>
                    Buscar
                  </MDButton>
                  <MDButton variant="contained" color="error" onClick={handleClear}>
                    Limpiar
                  </MDButton>
                  <MDButton
                    variant="contained"
                    color="success"
                    onClick={handleOpenExportarExcel}
                    startIcon={<FileDownload />}
                  >
                    Excel
                  </MDButton>
                </MDBox>
                </div>

                {loading ? (
                  <MDBox display="flex" justifyContent="center" alignItems="center" py={6}>
                    <CircularProgress />
                  </MDBox>
                ) : (
                  <DataTable
                    name={cfg.tablaStorage}
                    key={refreshKey}
                    table={{ columns, rows }}
                    isSorted={false}
                    showTotalEntries
                    canSearch={false}
                    noEndBorder
                    pagination={{ color: "info", variant: "gradient" }}
                    scrollHeight="60vh"
                    entriesPerPage={{
                      defaultValue: entriesPerPage,
                      entries: [10, 25, 50, 100, 200],
                      onChange: handleEntriesPerPageChange
                    }}
                  />
                )}

                <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
                  <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} elevation={6} variant="filled">
                    {snackbar.msg}
                  </MuiAlert>
                </Snackbar>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog open={objetosDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseObjetosDialog(); }} maxWidth="md" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Objetos Completos
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDTypography variant="body2" color="text" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            <div dangerouslySetInnerHTML={{
              __html: (() => {
                let texto = objetosDialog.contenido;
                // Agregar espacio después de cada coma que está seguida de un número
                texto = texto.replace(/,(\d)/g, ',  $1');
                // Agregar salto de línea después de punto y coma
                texto = texto.replace(/;\s*/g, ';\n');
                // Poner en negrita el texto descriptivo (palabras antes de "Cuenta n°")
                texto = texto.replace(/^([^0-9\n]+)(Cuenta n°)/gm, '<span style="font-weight: 800; color: #1976d2;">$1</span>$2');
                return texto;
              })()
            }} />
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleCloseObjetosDialog} color="info">
            Cerrar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Vincular Sujeto Real */}
      <Dialog open={vincularDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseVincular(); }} maxWidth="md" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Vincular Sujeto Real al Caso #{vincularDialog.idCaso}
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
            <MDBox>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Sujeto actual del caso: {vincularDialog.nombreSujetoCaso}
              </MDTypography>
              <MDTypography variant="caption" color="secondary" display="block">
                Identificación: {vincularDialog.identificacionCaso}
              </MDTypography>
              {vincularDialog.sujetoRealVinculado === 1 && (
                <MDBox mt={1} p={1.5} sx={{ backgroundColor: '#fff3e0', borderRadius: 1, border: '1px solid #ff9800' }}>
                  <MDTypography variant="caption" color="warning" fontWeight="bold">
                    ⚠ Este caso ya tiene un sujeto real vinculado. No se puede modificar la vinculación.
                  </MDTypography>
                </MDBox>
              )}
            </MDBox>

            <MDBox display="flex" gap={2} flexWrap="wrap" alignItems="flex-start">
              <MDBox>
                <MDInput
                  name="nombre"
                  label="Nombre del Sujeto"
                  value={vincularFilters.nombre}
                  onChange={handleVincularFilterChange}
                  onKeyDown={handleVincularKeyDown}
                  sx={{ minWidth: 250 }}
                />
              </MDBox>

              <MDBox>
                <MDInput
                  name="identificacion"
                  label="CUIT (11 dígitos)"
                  value={vincularFilters.identificacion}
                  onChange={handleVincularFilterChange}
                  onKeyDown={handleVincularKeyDown}
                  error={!!vincularValidationErrors.cuit}
                  inputProps={{ maxLength: 11 }}
                  sx={{ minWidth: 150 }}
                />
                {vincularValidationErrors.cuit && (
                  <MDTypography variant="caption" color="error" display="block" mt={0.5}>
                    {vincularValidationErrors.cuit}
                  </MDTypography>
                )}
              </MDBox>

              <MDBox>
                <MDInput
                  name="dni"
                  label="DNI (8 dígitos)"
                  value={vincularFilters.dni}
                  onChange={handleVincularFilterChange}
                  onKeyDown={handleVincularKeyDown}
                  error={!!vincularValidationErrors.dni}
                  inputProps={{ maxLength: 8 }}
                  sx={{ minWidth: 150 }}
                />
                {vincularValidationErrors.dni && (
                  <MDTypography variant="caption" color="error" display="block" mt={0.5}>
                    {vincularValidationErrors.dni}
                  </MDTypography>
                )}
              </MDBox>

              <MDButton variant="contained" color="info" onClick={handleBuscarSujetos} disabled={loadingSujetos}>
                {loadingSujetos ? <CircularProgress size={20} color="inherit" /> : "Buscar"}
              </MDButton>
            </MDBox>

            {vincularValidationErrors.both && (
              <MDBox>
                <MDTypography variant="caption" color="error" fontWeight="bold">
                  ⚠ {vincularValidationErrors.both}
                </MDTypography>
              </MDBox>
            )}

            <Autocomplete
              options={sujetosOptions}
              getOptionLabel={(option) => {
                if (!option) return "";
                return `${option.nombre}\nDomicilio: ${option.domicilio || 'No especificado'}\n${option.tipoIdentificacion}: ${option.identificacion}`;
              }}
              value={selectedSujeto}
              onChange={(e, newValue) => setSelectedSujeto(newValue)}
              renderOption={(props, option) => (
                <li {...props}>
                  <MDBox display="flex" flexDirection="column" width="100%">
                    <MDTypography variant="body2" fontWeight="bold">
                      {option.nombre}
                    </MDTypography>
                    <MDTypography variant="caption" color="text" fontSize="0.75rem">
                      Domicilio: {option.domicilio || 'No especificado'}
                    </MDTypography>
                    <MDTypography variant="caption" color="secondary" fontSize="0.75rem">
                      {option.tipoIdentificacion}: {option.identificacion}
                    </MDTypography>
                  </MDBox>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleccione el Sujeto Real"
                  InputProps={{
                    ...params.InputProps,
                    style: { minHeight: '80px', alignItems: 'flex-start', paddingTop: '8px' }
                  }}
                  multiline
                  rows={3}
                />
              )}
              disabled={loadingSujetos}
              noOptionsText="No se encontraron sujetos. Realice una búsqueda."
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="contained" color="error" onClick={handleCloseVincular} disabled={vinculando}>
            Cancelar
          </MDButton>
          <MDButton
            variant="contained"
            color="success"
            onClick={handleAceptarVincular}
            disabled={vinculando || !selectedSujeto || vincularDialog.sujetoRealVinculado === 1}
          >
            {vinculando ? <CircularProgress size={18} color="inherit" /> : "Aceptar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Agendar */}
      <Dialog open={agendaDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseAgenda(); }} maxWidth="sm" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Agendar Llamada - Caso #{agendaDialog.idCaso}
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
            <MDBox>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Sujeto: {agendaDialog.nombreSujeto}
              </MDTypography>
            </MDBox>

            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
              <DatePicker
                label="Fecha de la llamada"
                value={agendaDialog.fecha}
                onChange={(newValue) => setAgendaDialog({ ...agendaDialog, fecha: newValue })}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: "outlined"
                  }
                }}
              />
            </LocalizationProvider>

            <TextField
              label="Observaciones"
              multiline
              rows={6}
              value={agendaDialog.observaciones}
              onChange={(e) => {
                if (e.target.value.length <= 1000) {
                  setAgendaDialog({ ...agendaDialog, observaciones: e.target.value });
                }
              }}
              fullWidth
              variant="outlined"
              helperText={`${agendaDialog.observaciones.length}/1000 caracteres`}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="contained" color="error" onClick={handleCloseAgenda} disabled={guardandoAgenda}>
            Cancelar
          </MDButton>
          <MDButton variant="contained" color="success" onClick={handleGuardarAgenda} disabled={guardandoAgenda}>
            {guardandoAgenda ? <CircularProgress size={18} color="inherit" /> : "Guardar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Notificaciones Agenda */}
      <Dialog open={notificacionesDialog} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseNotificaciones(); }} maxWidth="md" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Agendas
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          {/* Filtros */}
          <MDBox mb={3} display="flex" gap={2} flexWrap="wrap" alignItems="center">
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
              <DatePicker
                label="Fecha Desde"
                value={agendaFilters.fechaDesde}
                onChange={(newValue) => setAgendaFilters({ ...agendaFilters, fechaDesde: newValue })}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { minWidth: 180 }
                  }
                }}
              />
              <DatePicker
                label="Fecha Hasta"
                value={agendaFilters.fechaHasta}
                onChange={(newValue) => setAgendaFilters({ ...agendaFilters, fechaHasta: newValue })}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { minWidth: 180 }
                  }
                }}
              />
            </LocalizationProvider>

            <MDButton variant="contained" color="info" onClick={handleBuscarAgendas} disabled={loadingAgendas}>
              Buscar
            </MDButton>
          </MDBox>

          {/* Filtro de nombre sobre la grilla */}
          <MDBox mb={2}>
            <MDInput
              name="nombreSujeto"
              label="Buscar por Nombre de Sujeto"
              value={agendaFilters.nombreSujeto}
              onChange={handleAgendaFilterChange}
              fullWidth
              placeholder="Filtrar en la lista actual..."
            />
          </MDBox>

          {loadingAgendas ? (
            <MDBox display="flex" justifyContent="center" alignItems="center" py={4}>
              <CircularProgress />
            </MDBox>
          ) : agendasFiltradas.length === 0 ? (
            <MDBox py={3} textAlign="center">
              <MDTypography variant="body2" color="text">
                {agendaFilters.nombreSujeto ? "No se encontraron agendas con ese nombre" : "No hay agendas en el rango seleccionado"}
              </MDTypography>
            </MDBox>
          ) : (
            <List sx={{ maxHeight: 400, overflowY: 'auto', overflowX: 'hidden' }}>
              {agendasFiltradas.map((agenda, index) => (
                <div key={agenda.idAgenda}>
                  <ListItem
                    sx={{
                      backgroundColor: agenda.visto ? 'transparent' : '#e3f2fd',
                      '&:hover': { backgroundColor: '#f5f5f5' },
                      py: 0.5
                    }}
                    secondaryAction={
                      <IconButton 
                        edge="end" 
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!agenda.visto) {
                            handleMarcarVisto(agenda.idAgenda);
                          }
                        }}
                        disabled={agenda.visto}
                        sx={{ 
                          color: agenda.visto ? 'success.main' : 'warning.main',
                          '&:hover': !agenda.visto ? { backgroundColor: 'rgba(237, 108, 2, 0.08)' } : {},
                          cursor: agenda.visto ? 'default' : 'pointer'
                        }}
                      >
                        {agenda.visto ? (
                          <CheckCircle fontSize="small" />
                        ) : (
                          <RadioButtonUnchecked fontSize="small" />
                        )}
                      </IconButton>
                    }
                  >
                    <ListItemText
                      primary={
                        <MDBox>
                          <MDTypography variant="caption" fontWeight="bold" sx={{ fontSize: '0.813rem' }}>
                            {agenda.nombreSujeto}
                          </MDTypography>
                          <MDTypography variant="caption" color="text" sx={{ fontSize: '0.75rem' }}>
                            <br/>
                            <Chip size="small" variant="outlined" color="info" label={etiquetaTipoCaso(agenda.tipo)} sx={{ mr: 0.5, height: 18, fontSize: '0.65rem' }} />
                            Caso #{agenda.idCaso} - Fecha Agendada: {dayjs(agenda.fecha).format('DD/MM/YYYY')}
                          </MDTypography>
                        </MDBox>
                      }
                      secondary={
                        <MDTypography 
                          variant="caption" 
                          color="text" 
                          sx={{ 
                            fontSize: '0.75rem',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                        >
                          {agenda.observaciones}
                        </MDTypography>
                      }
                    />
                  </ListItem>
                  {index < agendasFiltradas.length - 1 && <Divider />}
                </div>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton variant="contained" color="info" onClick={handleCloseNotificaciones}>
            Cerrar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Seguimiento/Eventos del Caso */}
      <Dialog open={seguimientoDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseSeguimiento(); }} fullWidth maxWidth="xl" disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDBox display="flex" alignItems="center" justifyContent="space-between">
            <MDTypography variant="h5" fontWeight="bold">
              Seguimiento del Caso #{seguimientoDialog.idCaso}
            </MDTypography>
            <MDBox display="flex" gap={1}>
              <MuiIconButton
                onClick={handleImprimirSeguimiento}
                color="primary"
                disabled={seguimientoDialog.loading || seguimientoDialog.eventos.length === 0}
                title="Imprimir"
              >
                <Print />
              </MuiIconButton>
              <MuiIconButton
                onClick={handleOpenMailDialog}
                color="info"
                disabled={seguimientoDialog.loading || seguimientoDialog.eventos.length === 0}
                title="Enviar por correo"
              >
                <EmailOutlined />
              </MuiIconButton>
            </MDBox>
          </MDBox>
        </DialogTitle>
        <DialogContent>
          {seguimientoDialog.loading ? (
            <MDBox display="flex" justifyContent="center" alignItems="center" py={6}>
              <CircularProgress />
            </MDBox>
          ) : seguimientoDialog.eventos.length === 0 ? (
            <MDBox py={3} textAlign="center">
              <MDTypography variant="body2" color="text">
                No hay eventos registrados para este caso
              </MDTypography>
            </MDBox>
          ) : (
            <MDBox sx={{ overflowX: 'auto' }}>
              <DataTable
                table={{
                  columns: [
                    { Header: 'Fecha/Hora', accessor: 'fecha', align: 'left', width: '12%' },
                    { Header: 'Usuario', accessor: 'usuario', align: 'left', width: '15%' },
                    { Header: 'Tipo Evento', accessor: 'tipoEvento', align: 'left', width: '15%' },
                    { Header: 'Observaciones', accessor: 'observaciones', align: 'left', width: '45%' }
                  ],
                  rows: seguimientoDialog.eventos.map(evento => ({
                    fecha: (
                      <MDTypography variant="caption" color="text">
                        {dayjs(evento.fecha).format('DD/MM/YYYY HH:mm:ss')}
                      </MDTypography>
                    ),
                    usuario: (
                      <MDTypography variant="caption" color="text">
                        {evento.usuarioNombre}
                      </MDTypography>
                    ),
                    tipoEvento: (
                      <MDTypography variant="caption" color="text">
                        {evento.eventoTipo}
                      </MDTypography>
                    ),
                    observaciones: (
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          color="text"
                          sx={{
                            whiteSpace: observacionesExpandidas[evento.idCasoEvento] ? 'pre-wrap' : 'nowrap',
                            overflow: observacionesExpandidas[evento.idCasoEvento] ? 'visible' : 'hidden',
                            textOverflow: observacionesExpandidas[evento.idCasoEvento] ? 'clip' : 'ellipsis',
                            cursor: evento.observaciones?.length > 75 ? 'pointer' : 'default'
                          }}
                          onClick={() => evento.observaciones?.length > 75 && toggleObservaciones(evento.idCasoEvento)}
                        >
                          {observacionesExpandidas[evento.idCasoEvento]
                            ? evento.observaciones
                            : (evento.observaciones?.length > 75
                              ? `${evento.observaciones.substring(0, 75)}...`
                              : evento.observaciones)
                          }
                        </MDTypography>
                      </MDBox>
                    )
                  }))
                }}
                entriesPerPage={{ defaultValue: 10, entries: [5, 10, 20, 50] }}
                canSearch={false}
                showTotalEntries={true}
                isSorted={false}
                noEndBorder={false}
                pagination={{ variant: "gradient", color: "info" }}
              />
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton variant="contained" color="info" onClick={handleCloseSeguimiento}>
            Volver
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Enviar Mail */}
      <Dialog open={mailDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseMailDialog(); }} maxWidth="md" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Enviar Seguimiento por Correo - Caso #{mailDialog.idCaso}
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
            <TextField
              label="Para *"
              type="email"
              value={mailDialog.para}
              onChange={(e) => setMailDialog({ ...mailDialog, para: e.target.value })}
              fullWidth
              placeholder="destinatario@ejemplo.com"
            />
            <TextField
              label="CC"
              type="email"
              value={mailDialog.cc}
              onChange={(e) => setMailDialog({ ...mailDialog, cc: e.target.value })}
              fullWidth
              placeholder="copia@ejemplo.com (opcional)"
            />
            <TextField
              label="Asunto *"
              value={mailDialog.asunto}
              onChange={(e) => setMailDialog({ ...mailDialog, asunto: e.target.value })}
              fullWidth
            />
            <TextField
              label="Cuerpo del mensaje *"
              multiline
              rows={6}
              value={mailDialog.cuerpo}
              onChange={(e) => setMailDialog({ ...mailDialog, cuerpo: e.target.value })}
              fullWidth
              placeholder="Escriba el mensaje aquí..."
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="contained" color="error" onClick={handleCloseMailDialog} disabled={mailDialog.enviando}>
            Cancelar
          </MDButton>
          <MDButton variant="contained" color="success" onClick={handleEnviarMail} disabled={mailDialog.enviando}>
            {mailDialog.enviando ? <CircularProgress size={18} color="inherit" /> : "Enviar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Agregar Evento */}
      <Dialog open={eventoDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseEvento(); }} maxWidth="sm" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Agregar Evento - Caso #{eventoDialog.idCaso}
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
            <Autocomplete
              options={tiposEvento.filter(t => t.activo)}
              getOptionLabel={(option) => option.label || ""}
              value={eventoDialog.tipoEvento}
              onChange={(event, newValue) => setEventoDialog({ ...eventoDialog, tipoEvento: newValue })}
              renderInput={(params) => (
                <TextField {...params} label="Tipo de Evento *" placeholder="Seleccione un tipo de evento" />
              )}
              fullWidth
            />

            {/* Disparador de gestiones (3.2d): avisa, antes de guardar, si el caso va a poder volver a proponerse. Solo con el Disparador
                encendido: apagado no tiene sentido hablar de proponer casos. */}
            {modo === "prejudicial" && propuesta?.disparadorActivo === true && eventoDialog.tipoEvento && eventoDialog.tipoEvento.vuelve !== undefined &&
              (!eventoDialog.tipoEvento.vuelve || eventoDialog.tipoEvento.dias != null) && (
              <MuiAlert severity={eventoDialog.tipoEvento.vuelve ? "info" : "warning"} icon={false} sx={{ py: 0 }}>
                {!eventoDialog.tipoEvento.vuelve
                  ? "Con este evento el caso no volverá a proponerse hasta que se cargue otro evento que lo permita."
                  : eventoDialog.tipoEvento.dias > 0
                    ? `Con este evento el caso volverá a proponerse en ${eventoDialog.tipoEvento.dias} ${eventoDialog.tipoEvento.dias === 1 ? "día" : "días"}.`
                    : "Con este evento el caso puede volver a proponerse enseguida."}
              </MuiAlert>
            )}

            <TextField
              label="Observaciones *"
              multiline
              rows={6}
              value={eventoDialog.observaciones}
              onChange={(e) => {
                if (e.target.value.length <= 500) {
                  setEventoDialog({ ...eventoDialog, observaciones: e.target.value });
                }
              }}
              fullWidth
              variant="outlined"
              helperText={`${eventoDialog.observaciones.length}/500 caracteres`}
              placeholder="Ingrese las observaciones del evento..."
            />

            <FormControlLabel
              control={
                <Switch
                  checked={eventoDialog.agendarLlamada}
                  onChange={(e) => setEventoDialog({ ...eventoDialog, agendarLlamada: e.target.checked })}
                  color="info"
                />
              }
              label="Agendar llamada"
            />

            {eventoDialog.agendarLlamada && (
              <>
                <MDTypography variant="caption" color="text" fontWeight="bold">
                  Sujeto: {eventoDialog.nombreSujeto}
                </MDTypography>

                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                  <DatePicker
                    label="Fecha de la llamada"
                    value={eventoDialog.fechaAgenda}
                    onChange={(newValue) => setEventoDialog({ ...eventoDialog, fechaAgenda: newValue })}
                    format="DD/MM/YYYY"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        variant: "outlined"
                      }
                    }}
                  />
                </LocalizationProvider>

                <TextField
                  label="Observaciones de la agenda"
                  multiline
                  rows={4}
                  value={eventoDialog.observacionesAgenda}
                  onChange={(e) => {
                    if (e.target.value.length <= 1000) {
                      setEventoDialog({ ...eventoDialog, observacionesAgenda: e.target.value });
                    }
                  }}
                  fullWidth
                  variant="outlined"
                  helperText={`${eventoDialog.observacionesAgenda.length}/1000 caracteres`}
                  placeholder="Observaciones para la agenda..."
                />
              </>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="contained" color="error" onClick={handleCloseEvento} disabled={eventoDialog.guardando}>
            Cancelar
          </MDButton>
          <MDButton variant="contained" color="success" onClick={handleGuardarEvento} disabled={eventoDialog.guardando}>
            {eventoDialog.guardando ? <CircularProgress size={18} color="inherit" /> : "Guardar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Info Sujeto Vinculado */}
      <Dialog open={infoSujetoDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseInfoSujeto(); }} maxWidth="md" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Información del Sujeto Vinculado
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={2}>
            <MDBox>
              <MDTypography variant="caption" color="text" fontWeight="bold" display="block" mb={0.5}>
                Sujeto real vinculado:
              </MDTypography>
              <MDTypography variant="body2" color="text">
                {infoSujetoDialog.nombreSujeto || "N/A"}
              </MDTypography>
              <MDTypography variant="caption" color="secondary" display="block">
                {infoSujetoDialog.tipoIdentificacion || "N/A"}: {infoSujetoDialog.identificacion || "N/A"}
              </MDTypography>
            </MDBox>

            {infoSujetoDialog.loading ? (
              <MDBox display="flex" justifyContent="center" alignItems="center" py={3}>
                <CircularProgress size={30} />
              </MDBox>
            ) : (
              contenidoProvisorios()
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="contained" color="info" onClick={handleCloseInfoSujeto} disabled={infoSujetoDialog.transfering}>
            Cerrar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Contactos */}
      <Dialog open={contactosDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseContactos(); }} maxWidth="md" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Contactos de {contactosDialog.nombreSujeto}
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={1.5}>
            {contactosDialog.contactos.length > 0 ? (
              contactosDialog.contactos.map((contacto) => (
                <MDBox
                  key={contacto.idSujetoContacto}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  p={1.5}
                  sx={{
                    backgroundColor: 'rgba(0,0,0,0.02)',
                    borderRadius: 1,
                    border: '1px solid rgba(0,0,0,0.08)'
                  }}
                >
                  <MDBox display="flex" alignItems="center" gap={1} flex={1}>
                    {contacto.tipoContacto?.toLowerCase().includes('mail') || contacto.tipoContacto?.toLowerCase().includes('email') ? (
                      <Email sx={{ fontSize: 20, color: 'primary.main' }} />
                    ) : (
                      <Phone sx={{ fontSize: 20, color: 'info.main' }} />
                    )}
                    <MDBox>
                      <MDTypography variant="body2" fontWeight="medium">
                        <span style={{ color: 'inherit' }}>{contacto.tipoContacto}</span>
                        {contacto.prioridadNombre && (
                          <span style={{
                            color: contacto.prioridadNombre?.toLowerCase() === 'prioritario' ? '#1976d2' : '#d32f2f',
                            fontWeight: 600
                          }}>
                            {` - ${contacto.prioridadNombre}`}
                          </span>
                        )}
                      </MDTypography>
                      <MDTypography variant="caption" color="text">
                        {contacto.contacto}
                      </MDTypography>
                      {contacto.origen && (
                        <MDTypography variant="caption" color="secondary" display="block">
                          Origen: {contacto.origen}
                        </MDTypography>
                      )}
                    </MDBox>
                  </MDBox>
                  <MDBox display="flex" gap={0.5}>
                    <MuiIconButton
                      size="small"
                      onClick={() => handleOpenEditContacto(contacto, contactosDialog.idSujeto)}
                      sx={{ padding: '6px' }}
                    >
                      <Edit color="info" fontSize="small" />
                    </MuiIconButton>
                    <MuiIconButton
                      size="small"
                      onClick={() => handleOpenDeleteContacto(contacto.idSujetoContacto)}
                      sx={{ padding: '6px' }}
                    >
                      <Close color="error" fontSize="small" />
                    </MuiIconButton>
                  </MDBox>
                </MDBox>
              ))
            ) : (
              <MDTypography variant="body2" color="text" textAlign="center" p={2}>
                No hay contactos registrados
              </MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="contained" color="success" onClick={() => handleOpenAddContacto(contactosDialog.idSujeto)} startIcon={<Add />}>
            Agregar
          </MDButton>
          <MDButton variant="contained" color="info" onClick={handleCloseContactos}>
            Cerrar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Edit Contacto */}
      <Dialog open={editContactoDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseEditContacto(); }} maxWidth="sm" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Editar Contacto
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
            <Autocomplete
              options={tiposContacto.filter(t => t.activo)}
              getOptionLabel={(option) => option.label || ""}
              value={editContactoDialog.selectedTipo}
              onChange={(event, newValue) => setEditContactoDialog(prev => ({ ...prev, selectedTipo: newValue }))}
              renderInput={(params) => (
                <TextField {...params} label="Tipo de Contacto *" placeholder="Seleccione un tipo" />
              )}
              fullWidth
            />

            <Autocomplete
              options={origenesContacto.filter(o => o.activo)}
              getOptionLabel={(option) => option.label || ""}
              value={editContactoDialog.selectedOrigen}
              onChange={(event, newValue) => setEditContactoDialog(prev => ({ ...prev, selectedOrigen: newValue }))}
              renderInput={(params) => (
                <TextField {...params} label="Origen *" placeholder="Seleccione un origen" />
              )}
              fullWidth
            />

            <Autocomplete
              options={prioridadesContacto.filter(p => p.activo)}
              getOptionLabel={(option) => option.label || ""}
              value={editContactoDialog.selectedPrioridad}
              onChange={(event, newValue) => setEditContactoDialog(prev => ({ ...prev, selectedPrioridad: newValue }))}
              renderInput={(params) => (
                <TextField {...params} label="Prioridad" placeholder="Seleccione una prioridad (opcional)" />
              )}
              fullWidth
            />

            <TextField
              label="Contacto *"
              value={editContactoDialog.valorContacto}
              onChange={(e) => setEditContactoDialog(prev => ({ ...prev, valorContacto: e.target.value }))}
              fullWidth
              variant="outlined"
              placeholder="Ingrese el contacto..."
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            variant="contained"
            color="error"
            onClick={handleCloseEditContacto}
            disabled={editContactoDialog.saving}
          >
            Cancelar
          </MDButton>
          <MDButton
            variant="contained"
            color="success"
            onClick={handleSaveEditContacto}
            disabled={editContactoDialog.saving}
          >
            {editContactoDialog.saving ? <CircularProgress size={18} color="inherit" /> : "Guardar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Agregar Contacto */}
      <Dialog open={addContactoDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseAddContacto(); }} maxWidth="sm" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Agregar Contacto
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
            <Autocomplete
              options={tiposContacto.filter(t => t.activo)}
              getOptionLabel={(option) => option.label || ""}
              value={addContactoDialog.selectedTipo}
              onChange={(event, newValue) => setAddContactoDialog(prev => ({ ...prev, selectedTipo: newValue }))}
              renderInput={(params) => (
                <TextField {...params} label="Tipo de Contacto *" placeholder="Seleccione un tipo" />
              )}
              fullWidth
            />

            <Autocomplete
              options={origenesContacto.filter(o => o.activo)}
              getOptionLabel={(option) => option.label || ""}
              value={addContactoDialog.selectedOrigen}
              onChange={(event, newValue) => setAddContactoDialog(prev => ({ ...prev, selectedOrigen: newValue }))}
              renderInput={(params) => (
                <TextField {...params} label="Origen *" placeholder="Seleccione un origen" />
              )}
              fullWidth
            />

            <Autocomplete
              options={prioridadesContacto.filter(p => p.activo)}
              getOptionLabel={(option) => option.label || ""}
              value={addContactoDialog.selectedPrioridad}
              onChange={(event, newValue) => setAddContactoDialog(prev => ({ ...prev, selectedPrioridad: newValue }))}
              renderInput={(params) => (
                <TextField {...params} label="Prioridad" placeholder="Seleccione una prioridad (opcional)" />
              )}
              fullWidth
            />

            <TextField
              label="Contacto *"
              value={addContactoDialog.valorContacto}
              onChange={(e) => setAddContactoDialog(prev => ({ ...prev, valorContacto: e.target.value }))}
              fullWidth
              variant="outlined"
              placeholder="Ingrese el contacto..."
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            variant="contained"
            color="error"
            onClick={handleCloseAddContacto}
            disabled={addContactoDialog.saving}
          >
            Cancelar
          </MDButton>
          <MDButton
            variant="contained"
            color="success"
            onClick={handleSaveAddContacto}
            disabled={addContactoDialog.saving}
          >
            {addContactoDialog.saving ? <CircularProgress size={18} color="inherit" /> : "Guardar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Delete Contacto Confirmation */}
      <Dialog open={deleteContactoDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseDeleteContacto(); }} maxWidth="xs" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Confirmar Eliminación
          </MDTypography>
        </DialogTitle>
        <DialogContent>
          <MDTypography variant="body2" color="text">
            ¿Está seguro que desea eliminar este contacto?
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton variant="contained" color="secondary" onClick={handleCloseDeleteContacto}>
            Cancelar
          </MDButton>
          <MDButton variant="contained" color="error" onClick={handleConfirmDeleteContacto}>
            Eliminar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Historial de Casos del Sujeto */}
      <Dialog open={historialCasosDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseHistorialCasos(); }} maxWidth="lg" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Historial de Casos - {historialCasosDialog.nombreSujeto}
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          {historialCasosDialog.loading ? (
            <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
              <CircularProgress />
            </MDBox>
          ) : historialCasosDialog.casos.length > 0 ? (
            <MDBox display="flex" flexDirection="column" gap={2}>
              {historialCasosDialog.casos.map((caso) => (
                <MDBox
                  key={caso.idCaso}
                  p={2}
                  sx={{
                    backgroundColor: 'rgba(0,0,0,0.02)',
                    borderRadius: 1,
                    border: '1px solid rgba(0,0,0,0.08)'
                  }}
                >
                  <MDBox display="flex" justifyContent="space-between" alignItems="start" mb={1}>
                    <MDBox>
                      <MDTypography variant="h6" color="text" fontWeight="medium">
                        Caso #{caso.idCaso}
                      </MDTypography>
                      <MDTypography variant="caption" color="info" fontWeight="bold" display="block" mt={0.5}>
                        Organismo: {caso.organismo}
                      </MDTypography>
                      {caso.motivo && (
                        <MDTypography variant="caption" color="text" fontWeight="bold" display="block">
                          Motivo: {caso.motivo}
                        </MDTypography>
                      )}
                      {caso.periodoGestion && (
                        <MDTypography variant="caption" color="text" fontWeight="bold" display="block">
                          Período: {caso.periodoGestion}
                        </MDTypography>
                      )}
                      <MDTypography variant="caption" color="warning" fontWeight="bold" display="block">
                        Estado de la Gestion: {caso.estado || 'N/A'}
                      </MDTypography>
                    </MDBox>
                    <MDBox textAlign="right">
                      <MDTypography variant="caption" color="text" fontWeight="medium" display="block">
                        Objetos: {caso.cantidadObjetos}
                      </MDTypography>
                      <MDTypography variant="caption" color="success" fontWeight="bold" display="block" mt={0.5}>
                        Monto: ${caso.monto?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </MDTypography>
                      {caso.tipoCierreDescripcion && caso.tipoCierreDescripcion !== 'SIN CERRAR' && (
                        <MDBox
                          mt={0.5}
                          p={0.5}
                          sx={{
                            backgroundColor: 'rgba(33, 150, 243, 0.1)',
                            border: '1px solid #2196f3',
                            borderRadius: 1,
                            display: 'inline-block'
                          }}
                        >
                          <MDTypography variant="caption" color="info" fontWeight="bold">
                            Estado de Cierre: {caso.tipoCierreDescripcion}
                          </MDTypography>
                        </MDBox>
                      )}
                    </MDBox>
                  </MDBox>

                  {caso.objetos && (
                    <MDTypography variant="caption" color="text" display="block" mt={1} mb={2}>
                      <strong>Objetos:</strong>{' '}
                      <span dangerouslySetInnerHTML={{
                        __html: (() => {
                          let texto = caso.objetos;// caso.objetos.length > 150 ? `${caso.objetos.substring(0, 150)}...` : caso.objetos;
                          // Eliminar todos los saltos de línea existentes
                          texto = texto.replace(/\r?\n/g, '');
                          // Primero poner en negrita el texto descriptivo (palabras antes de "Cuenta n°")
                          texto = texto.replace(/([A-Za-záéíóúÁÉÍÓÚñÑ\s]+)(Cuenta n°)/g, '<span style="font-weight: 800; color: #1976d2;">$1</span>$2');
                          // Agregar espacio no separable después de cada coma (no salto de línea)
                          texto = texto.replace(/,\s*/g, ', ');
                          // Agregar salto de línea SOLO después de punto y coma
                          texto = texto.replace(/;\s*/g, ';<br>');
                          return texto;
                        })()
                      }} />
                    </MDTypography>
                  )}

                  {Array.isArray(caso.casoDetalle) && caso.casoDetalle.length > 0 && (
                    <MDBox mt={2}>
                      <MDTypography variant="caption" color="text" fontWeight="bold" display="block" mb={1}>
                        Detalle de Eventos:
                      </MDTypography>
                      <MDBox display="flex" flexDirection="column" gap={1}>
                        {caso.casoDetalle.map((detalle, idx) => (
                          <MDBox
                            key={idx}
                            p={1.5}
                            sx={{
                              backgroundColor: 'white',
                              borderRadius: 0.5,
                              border: '1px solid rgba(0,0,0,0.05)'
                            }}
                          >
                            <MDBox display="flex" justifyContent="space-between" alignItems="start" mb={0.5}>
                              <MDTypography variant="caption" color="secondary" fontWeight="medium">
                                {dayjs(detalle.fecha).format('DD/MM/YYYY HH:mm:ss')}
                              </MDTypography>
                              <MDTypography variant="caption" color="text" fontWeight="medium">
                                {detalle.usuario}
                              </MDTypography>
                            </MDBox>
                            <MDTypography variant="caption" color="info" fontWeight="bold" display="block" mb={0.5}>
                              {detalle.tipoEvento}
                            </MDTypography>
                            <MDTypography variant="caption" color="text">
                              {detalle.observaciones}
                            </MDTypography>
                          </MDBox>
                        ))}
                      </MDBox>
                    </MDBox>
                  )}
                </MDBox>
              ))}
            </MDBox>
          ) : (
            <MDTypography variant="body2" color="text" textAlign="center" p={2}>
              No se encontraron casos para este sujeto
            </MDTypography>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton variant="contained" color="info" onClick={handleCloseHistorialCasos}>
            Cerrar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Cambiar Gestor */}
      <Dialog open={cambiarGestorDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseCambiarGestor(); }} maxWidth="sm" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Cambiar Gestor - Caso #{cambiarGestorDialog.idCaso}
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={2} py={2}>
            <MDBox>
              <MDTypography variant="caption" color="text" fontWeight="bold" display="block" mb={0.5}>
                Gestor Actual:
              </MDTypography>
              <MDTypography variant="body2" color="info" fontWeight="medium">
                {cambiarGestorDialog.usuarioActual}
              </MDTypography>
            </MDBox>

            <Autocomplete
              options={usuarios}
              getOptionLabel={(option) => option.label || ""}
              getOptionDisabled={(option) => !option.activo}
              value={cambiarGestorDialog.selectedUsuario}
              onChange={(event, newValue) => {
                setCambiarGestorDialog(prev => ({ ...prev, selectedUsuario: newValue }));
              }}
              renderInput={(params) => <TextField {...params} label="Nuevo Gestor *" />}
              fullWidth
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="outlined" color="error" onClick={handleCloseCambiarGestor}>
            Cancelar
          </MDButton>
          <MDButton
            variant="contained"
            color="success"
            onClick={handleAceptarCambiarGestor}
            disabled={cambiarGestorDialog.guardando}
          >
            {cambiarGestorDialog.guardando ? <CircularProgress size={20} color="inherit" /> : "Aceptar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Dialog Exportar Excel */}
      <Dialog open={exportarExcelDialog.open} onClose={(event, reason) => { if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') handleCloseExportarExcel(); }} maxWidth="sm" fullWidth disableEscapeKeyDown PaperComponent={PaperComponent}>
        <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
          <MDTypography variant="h5" fontWeight="medium">
            Exportar a Excel
          </MDTypography>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={2} py={2}>
            <Autocomplete
              options={["Resumido", "Detallado"]}
              value={exportarExcelDialog.tipoReporte}
              onChange={(event, newValue) => {
                setExportarExcelDialog(prev => ({ ...prev, tipoReporte: newValue || "Resumido" }));
              }}
              renderInput={(params) => <TextField {...params} label="Tipo de Reporte" />}
              fullWidth
              disableClearable
            />

            <TextField
              label="Observaciones"
              multiline
              rows={4}
              value={
                exportarExcelDialog.tipoReporte === "Resumido"
                  ? "Reporte resumido de casos sin detalle de contactos"
                  : "Reporte de casos detallado con datos de contactos"
              }
              InputProps={{ readOnly: true }}
              fullWidth
              variant="outlined"
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="outlined" color="error" onClick={handleCloseExportarExcel} disabled={exportarExcelDialog.exportando}>
            Cancelar
          </MDButton>
          <MDButton
            variant="contained"
            color="success"
            onClick={handleExportarExcel}
            disabled={exportarExcelDialog.exportando}
            startIcon={exportarExcelDialog.exportando ? <CircularProgress size={16} color="inherit" /> : <FileDownload />}
          >
            {exportarExcelDialog.exportando ? "Exportando..." : "Exportar"}
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default CasosList;